import React, {useEffect, useState, useRef, useCallback} from "react";
import { Formik, Field, Form } from "formik";
import MainService from "../../services/main.service";
import clsx from "clsx";
import _ from "lodash";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
// css
import "../../assets/css/header.css";
import "../../assets/css/page.main.css";
import "../../assets/css/swiper.custom.css";
import "../../assets/css/media.css";
// icons
//import Burger from "../../components/icons/burger";
import Logo from "../../components/icons/logo.jsx";
import Drawer from '@mui/material/Drawer';
import Report from "../../components/icons/report";
import { CaretUpFill, PlayCircleFill, XLg } from "react-bootstrap-icons";
import p1 from "../../assets/img/p1.webp";
import p1Child from "../../assets/img/p1_dot.webp";
import choose1 from "../../assets/img/choose1.webp";
import choose2 from "../../assets/img/choose2.webp";
import in2 from "../../assets/img/in2.svg";
import overview from "../../assets/img/overview.png";
import info from "../../assets/img/info.png";
import SvgWhatsapp from "../../components/icons/svgWhatsapp";
import SvgTelegram from "../../components/icons/svgTelegram";
import SvgArrowLeft from "../../components/icons/svgArrowLeft";
import SvgArrowL from "../../components/icons/svgArrowL";
import SvgArrowRight from "../../components/icons/svgArrowRight";
import SvgArrowR from "../../components/icons/svgArrowR";
import SvgCar from "../../components/icons/svgCar";
import SvgArrow from "../../components/icons/svgArrow";
import video_about from "../../assets/video/about.mp4";
import SvgQRcode from "../../components/qr/qrcode";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import CustomSnackbar from "../../components/CustomSnackbar/CustomSnackbar.js"
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

const disablePinchZoom = () => {
  document.addEventListener("gesturestart", function (e) {
    e.preventDefault();
    // special hack to prevent zoom-to-tabs gesture in safari
    document.body.style.zoom = 0.99;
  });

  document.addEventListener("gesturechange", function (e) {
    e.preventDefault();
    // special hack to prevent zoom-to-tabs gesture in safari
    document.body.style.zoom = 0.99;
  });

  document.addEventListener("gestureend", function (e) {
    e.preventDefault();
    // special hack to prevent zoom-to-tabs gesture in safari
    document.body.style.zoom = 0.99;
  });
};

const timeout = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

const randomInteger = (min, max) => {
  // случайное целое число от min до (max+1)
  let rand = min + Math.random() * (max + 1 - min);
  return Math.floor(rand);
};

let firstScreenHeaderTextIndexVar = 0;
let apartamentsBlinkHouseVar = 1;

const layoutsData = [
  //1 корпус
  {
    housing: 1,
    number: 1,
    views: ["sea"],
    area: 39.8,
    layout: "3_39.8",
  },
  {
    housing: 1,
    number: 2,
    views: ["sea"],
    area: 39.8,
    layout: "3_39.8x",
  },
  {
    housing: 1,
    number: 3,
    views: ["sea"],
    area: 48.1,
    layout: "11_48.1x",
  },
  {
    housing: 1,
    number: 4,
    views: ["sea"],
    area: 48.1,
    layout: "11_48.1",
  },
  {
    housing: 1,
    number: 5,
    views: ["sea"],
    area: 44.1,
    layout: "8_44.1x",
  },
  {
    housing: 1,
    number: 6,
    views: ["sea"],
    area: 44.1,
    layout: "8_44.1",
  },
  {
    housing: 1,
    number: 7,
    views: ["sea"],
    area: 42.8,
    layout: "4_42.8x",
  },
  {
    housing: 1,
    number: 8,
    views: ["sea"],
    area: 42.8,
    layout: "4_42.8",
  },
  {
    housing: 1,
    number: 9,
    views: ["sea"],
    area: 44.1,
    layout: "8_44.1xy",
  },
  {
    housing: 1,
    number: 10,
    views: ["sea"],
    area: 44.1,
    layout: "8_44.1y",
  },
  {
    housing: 1,
    number: 11,
    views: ["sea"],
    area: 62.1,
    layout: "13_62.1x",
  },
  {
    housing: 1,
    number: 12,
    views: ["sea"],
    area: 47.7,
    layout: "11_47.7y",
  },
  {
    housing: 1,
    number: 13,
    views: ["sea"],
    area: 66.3,
    layout: "14_66.3x",
  },

  //2 корпус
  {
    housing: 2,
    number: 1,
    views: ["sea"],
    area: 77.5,
    //15_77.5
    layout: "15_77.5",
  },
  {
    housing: 2,
    number: 2,
    views: ["mountains"],
    area: 48.8,
    //16_48.8
    layout: "16_48.8",
  },
  {
    housing: 2,
    number: 3,
    views: ["sea"],
    area: 82.9,
    //17_82.9
    layout: "17_82.9",
  },
  {
    housing: 2,
    number: 4,
    views: ["sea"],
    area: 48.8,
    //16_48.8x
    layout: "16_48.8x",
  },
  {
    housing: 2,
    number: 5,
    views: ["sea"],
    area: 42.2,
    layout: "2_42.2",
  },
  {
    housing: 2,
    number: 6,
    views: ["mountains"],
    area: 48.6,
    layout: "9_48.6",
  },
  {
    housing: 2,
    number: 7,
    views: ["sea"],
    area: 45.9,
    layout: "11_45.9xr90",
  },
  {
    housing: 2,
    number: 8,
    views: ["mountains"],
    area: 43,
    layout: "10_43",
  },
  {
    housing: 2,
    number: 9,
    views: ["mountains"],
    area: 46,
    layout: "11_46r90",
  },
  {
    housing: 2,
    number: 10,
    views: ["mountains", "sea"],
    area: 59.5,
    layout: "13_59.5r90",
  },
  {
    housing: 2,
    number: 11,
    views: ["sea"],
    area: 66.7,
    layout: "14_66.7yr90",
  },
  //3 корпус
  {
    housing: 3,
    number: 1,
    views: ["sea"],
    area: 39.8,
    layout: "2_39.8r-90",
  },
  {
    housing: 3,
    number: 2,
    views: ["sea"],
    area: 39.8,
    layout: "2_39.8xr-90",
  },
  {
    housing: 3,
    number: 3,
    views: ["sea"],
    area: 48.5,
    layout: "11_48.5x",
  },
  {
    housing: 3,
    number: 4,
    views: ["sea"],
    area: 48.1,
    layout: "11_48.1",
  },
  {
    housing: 3,
    number: 5,
    views: ["sea"],
    area: 44,
    layout: "7_44",
  },
  {
    housing: 3,
    number: 6,
    views: ["sea"],
    area: 43.5,
    layout: "7_43.5x",
  },
  {
    housing: 3,
    number: 7,
    views: ["sea"],
    area: 42.1,
    layout: "4_42.1x",
  },
  {
    housing: 3,
    number: 8,
    views: ["sea"],
    area: 42.2,
    layout: "4_42.2",
  },
  {
    housing: 3,
    number: 9,
    views: ["sea"],
    area: 44.1,
    layout: "7_44.1y",
  },
  {
    housing: 3,
    number: 10,
    views: ["sea"],
    area: 43.4,
    layout: "7_43.4xy",
  },
  {
    housing: 3,
    number: 11,
    views: ["sea"],
    area: 47.8,
    layout: "11_47.8xy",
  },
  {
    housing: 3,
    number: 12,
    views: ["sea"],
    area: 62.1,
    layout: "13_62.1",
  },
  {
    housing: 3,
    number: 13,
    views: ["sea"],
    area: 65.9,
    layout: "14_65.9",
  },
  //4 корпус
  {
    housing: 4,
    number: 1,
    views: ["sea"],
    area: 79,
    layout: "15_79",
  },
  {
    housing: 4,
    number: 2,
    views: ["mountains"],
    area: 36.2,
    layout: "5_36.2x",
  },
  {
    housing: 4,
    number: 3,
    views: ["sea"],
    area: 80.5,
    layout: "18_80.5",
  },
  {
    housing: 4,
    number: 4,
    views: ["mountains"],
    area: 46.1,
    layout: "10_46.1r90",
  },
  {
    housing: 4,
    number: 5,
    views: ["sea"],
    area: 39.5,
    layout: "2_39.5",
  },
  {
    housing: 4,
    number: 6,
    views: ["mountains"],
    area: 55.8,
    layout: "19_55.8",
  },
  {
    housing: 4,
    number: 7,
    views: ["sea"],
    area: 46,
    layout: "10_46y",
  },
  {
    housing: 4,
    number: 8,
    views: ["mountains"],
    area: 50.1,
    layout: "20_50.1",
  },
  {
    housing: 4,
    number: 9,
    views: ["sea"],
    area: 46,
    layout: "10_46xy",
  },
  {
    housing: 4,
    number: 10,
    views: ["mountains"],
    area: 37.6,
    layout: "5_37.6",
  },
  {
    housing: 4,
    number: 11,
    views: ["sea"],
    area: 39.3,
    layout: "2_39.3x",
  },
  {
    housing: 4,
    number: 12,
    views: ["mountains"],
    area: 44.6,
    layout: "9_44.6x",
  },
  {
    housing: 4,
    number: 14,
    views: ["mountains"],
    area: 44.7,
    layout: "8_44.7r90",
  },
  {
    housing: 4,
    number: 16,
    views: ["mountains"],
    area: 44.6,
    layout: "8_44.6xr90",
  },
  {
    housing: 4,
    number: 18,
    views: ["mountains"],
    area: 44.2,
    layout: "9_44.2",
  },
  {
    housing: 4,
    number: 20,
    views: ["mountains"],
    area: 23.4,
    layout: "1_23.4",
  },
  //5 корпус
  {
    housing: 5,
    number: 1,
    views: ["sea"],
    area: 39.8,
    layout: "2_39.8r-90",
  },
  {
    housing: 5,
    number: 2,
    views: ["sea"],
    area: 39.8,
    layout: "2_39.8xr-90",
  },
  {
    housing: 5,
    number: 3,
    views: ["sea"],
    area: 48.5,
    layout: "11_48.5x",
  },
  {
    housing: 5,
    number: 4,
    views: ["sea"],
    area: 48.1,
    layout: "11_48.1",
  },
  {
    housing: 5,
    number: 5,
    views: ["sea"],
    area: 44,
    layout: "7_44",
  },
  {
    housing: 5,
    number: 6,
    views: ["sea"],
    area: 43.5,
    layout: "7_43.5x",
  },
  {
    housing: 5,
    number: 7,
    views: ["sea"],
    area: 42.1,
    layout: "4_42.1x",
  },
  {
    housing: 5,
    number: 8,
    views: ["sea"],
    area: 42.2,
    layout: "4_42.2",
  },
  {
    housing: 5,
    number: 9,
    views: ["sea"],
    area: 44.1,
    layout: "7_44.1y",
  },
  {
    housing: 5,
    number: 10,
    views: ["sea"],
    area: 43.4,
    layout: "7_43.4xy",
  },
  {
    housing: 5,
    number: 11,
    views: ["sea"],
    area: 47.8,
    layout: "11_47.8xy",
  },
  {
    housing: 5,
    number: 12,
    views: ["sea"],
    area: 62.1,
    layout: "13_62.1",
  },
  {
    housing: 5,
    number: 13,
    views: ["sea"],
    area: 65.9,
    layout: "14_65.9",
  },
  //6 корпус
  {
    housing: 6,
    number: 1,
    views: ["sea"],
    area: 79,
    layout: "15_79",
  },
  {
    housing: 6,
    number: 2,
    views: ["mountains"],
    area: 44.6,
    layout: "9_44.6x",
  },
  {
    housing: 6,
    number: 3,
    views: ["sea"],
    area: 80.5,
    layout: "18_80.5",
  },
  {
    housing: 6,
    number: 4,
    views: ["mountains"],
    area: 44.7,
    layout: "8_44.7r90",
  },
  {
    housing: 6,
    number: 5,
    views: ["sea"],
    area: 39.5,
    layout: "2_39.5",
  },
  {
    housing: 6,
    number: 6,
    views: ["mountains"],
    area: 44.6,
    layout: "8_44.6xr90",
  },
  {
    housing: 6,
    number: 7,
    views: ["sea"],
    area: 46,
    layout: "10_46y",
  },
  {
    housing: 6,
    number: 8,
    views: ["mountains"],
    area: 44.2,
    layout: "9_44.2",
  },
  {
    housing: 6,
    number: 9,
    views: ["sea"],
    area: 46,
    layout: "10_46xy",
  },
  {
    housing: 6,
    number: 10,
    views: ["mountains"],
    area: 23.4,
    layout: "1_23.4",
  },
  {
    housing: 6,
    number: 11,
    views: ["sea"],
    area: 39.3,
    layout: "2_39.3x",
  },
  //7 корпус
  {
    housing: 7,
    number: 1,
    views: ["mountains"],
    area: 37.6,
    layout: "5_37.6x",
  },
  {
    housing: 7,
    number: 2,
    views: ["mountains"],
    area: 37.4,
    layout: "5_37.4",
  },
  {
    housing: 7,
    number: 3,
    views: ["mountains"],
    area: 48,
    layout: "10_48r90",
  },
  {
    housing: 7,
    number: 4,
    views: ["mountains"],
    area: 48.1,
    layout: "10_48.1xr90",
  },
  {
    housing: 7,
    number: 5,
    views: ["mountains"],
    area: 44.3,
    layout: "21_44.3",
  },
  {
    housing: 7,
    number: 6,
    views: ["mountains"],
    area: 44.2,
    layout: "21_44.2x",
  },
  {
    housing: 7,
    number: 7,
    views: ["mountains"],
    area: 47.9,
    layout: "10_47.9yr90",
  },
  {
    housing: 7,
    number: 8,
    views: ["mountains"],
    area: 61.6,
    layout: "13_61.6y",
  },
  {
    housing: 7,
    number: 9,
    views: ["mountains"],
    area: 66.6,
    layout: "14_66.6y",
  },
  //8 корпус
  {
    housing: 8,
    number: 1,
    views: ["sea"],
    area: 39.8,
    layout: "2_39.8r-90",
  },
  {
    housing: 8,
    number: 2,
    views: ["sea"],
    area: 39.8,
    layout: "2_39.8xr-90",
  },
  {
    housing: 8,
    number: 3,
    views: ["sea"],
    area: 48.5,
    layout: "11_48.5x",
  },
  {
    housing: 8,
    number: 4,
    views: ["sea"],
    area: 48.1,
    layout: "11_48.1",
  },
  {
    housing: 8,
    number: 5,
    views: ["sea"],
    area: 44,
    layout: "7_44",
  },
  {
    housing: 8,
    number: 6,
    views: ["sea"],
    area: 43.5,
    layout: "7_43.5x",
  },
  {
    housing: 8,
    number: 7,
    views: ["sea"],
    area: 42.1,
    layout: "4_42.1x",
  },
  {
    housing: 8,
    number: 8,
    views: ["sea"],
    area: 42.2,
    layout: "4_42.2",
  },
  {
    housing: 8,
    number: 9,
    views: ["sea"],
    area: 44.1,
    layout: "7_44.1y",
  },
  {
    housing: 8,
    number: 10,
    views: ["sea"],
    area: 43.4,
    layout: "7_43.4xy",
  },
  {
    housing: 8,
    number: 11,
    views: ["sea"],
    area: 47.8,
    layout: "11_47.8xy",
  },
  {
    housing: 8,
    number: 12,
    views: ["sea"],
    area: 62.1,
    layout: "13_62.1",
  },
  {
    housing: 8,
    number: 13,
    views: ["sea"],
    area: 65.9,
    layout: "14_65.9",
  },
  //9 корпус
  {
    housing: 9,
    number: 1,
    views: ["sea"],
    area: 79,
    layout: "15_79",
  },
  {
    housing: 9,
    number: 2,
    views: ["mountains"],
    area: 44.6,
    layout: "9_44.6x",
  },
  {
    housing: 9,
    number: 3,
    views: ["sea"],
    area: 80.5,
    layout: "18_80.5",
  },
  {
    housing: 9,
    number: 4,
    views: ["mountains"],
    area: 44.7,
    layout: "8_44.7r90",
  },
  {
    housing: 9,
    number: 5,
    views: ["sea"],
    area: 39.5,
    layout: "2_39.5",
  },
  {
    housing: 9,
    number: 6,
    views: ["mountains"],
    area: 44.6,
    layout: "8_44.6xr90",
  },
  {
    housing: 9,
    number: 7,
    views: ["sea"],
    area: 46,
    layout: "10_46y",
  },
  {
    housing: 9,
    number: 8,
    views: ["mountains"],
    area: 44.2,
    layout: "9_44.2",
  },
  {
    housing: 9,
    number: 9,
    views: ["sea"],
    area: 46,
    layout: "10_46xy",
  },
  {
    housing: 9,
    number: 10,
    views: ["mountains"],
    area: 23.4,
    layout: "1_23.4",
  },
  {
    housing: 9,
    number: 11,
    views: ["sea"],
    area: 39.3,
    layout: "2_39.3x",
  },
  //10 корпус
  {
    housing: 10,
    number: 1,
    views: ["mountains"],
    area: 37.7,
    layout: "5_37.7x",
  },
  {
    housing: 10,
    number: 2,
    views: ["mountains"],
    area: 37.7,
    layout: "5_37.7",
  },
  {
    housing: 10,
    number: 3,
    views: ["mountains"],
    area: 48.1,
    layout: "11_48.1xy",
  },
  {
    housing: 10,
    number: 4,
    views: ["mountains"],
    area: 48.3,
    layout: "11_48.3y",
  },
  {
    housing: 10,
    number: 5,
    views: ["mountains"],
    area: 44,
    layout: "6_44r90",
  },
  {
    housing: 10,
    number: 6,
    views: ["mountains"],
    area: 44.2,
    layout: "6_44.2xr90",
  },
  {
    housing: 10,
    number: 7,
    views: ["mountains"],
    area: 44,
    layout: "6_44yr90",
  },
  {
    housing: 10,
    number: 8,
    views: ["mountains"],
    area: 44.2,
    layout: "6_44.2xyr90",
  },
  {
    housing: 10,
    number: 9,
    views: ["mountains"],
    area: 47.9,
    layout: "11_47.9x",
  },
  {
    housing: 10,
    number: 10,
    views: ["mountains"],
    area: 61.4,
    layout: "13_61.4y",
  },
  {
    housing: 10,
    number: 11,
    views: ["mountains"],
    area: 67.4,
    layout: "14_67.4y",
  },
  //корпус 11
  {
    housing: 11,
    number: 1,
    views: ["sea"],
    area: 39.8,
    layout: "2_39.8r-90",
  },
  {
    housing: 11,
    number: 2,
    views: ["sea"],
    area: 39.4,
    layout: "2_39.4xr-90",
  },
  {
    housing: 11,
    number: 3,
    views: ["sea"],
    area: 48.1,
    layout: "11_48.1x",
  },
  {
    housing: 11,
    number: 4,
    views: ["sea"],
    area: 48.1,
    layout: "11_48.1",
  },
  {
    housing: 11,
    number: 5,
    views: ["sea"],
    area: 44.1,
    layout: "7_44.1",
  },
  {
    housing: 11,
    number: 6,
    views: ["sea"],
    area: 44.1,
    layout: "7_44.1x",
  },
  {
    housing: 11,
    number: 7,
    views: ["sea"],
    area: 42.8,
    layout: "4_42.1x",
  },
  {
    housing: 11,
    number: 8,
    views: ["sea"],
    area: 42.8,
    layout: "4_42.8",
  },
  {
    housing: 11,
    number: 9,
    views: ["sea"],
    area: 44.1,
    layout: "7_44.1y",
  },

  {
    housing: 11,
    number: 10,
    views: ["sea"],
    area: 44.1,
    layout: "7_44.1xy",
  },
  {
    housing: 11,
    number: 11,
    views: ["sea"],
    area: 62.1,
    layout: "13_62.1x",
  },
  {
    housing: 11,
    number: 12,
    views: ["sea"],
    area: 47.7,
    layout: "11_47.7y",
  },
  {
    housing: 11,
    number: 14,
    views: ["sea"],
    area: 66.3,
    layout: "14_66.3x",
  },
  //корпус 12
  {
    housing: 12,
    number: 1,
    views: ["sea"],
    area: 64.9,
    layout: "22_64.9",
  },
  {
    housing: 12,
    number: 2,
    views: ["mountains"],
    area: 42.9,
    layout: "23_42.9",
  },
  {
    housing: 12,
    number: 3,
    views: ["sea"],
    area: 80.5,
    layout: "18_80.5",
  },
  {
    housing: 12,
    number: 4,
    views: ["mountains"],
    area: 44.6,
    layout: "9_44.6x",
  },
  {
    housing: 12,
    number: 5,
    views: ["sea"],
    area: 39.5,
    layout: "2_39.5",
  },
  {
    housing: 12,
    number: 6,
    views: ["mountains"],
    area: 44.7,
    layout: "8_44.7r90",
  },
  {
    housing: 12,
    number: 7,
    views: ["sea"],
    area: 46,
    layout: "10_46y",
  },
  {
    housing: 12,
    number: 8,
    views: ["mountains"],
    area: 44.6,
    layout: "8_44.6xr90",
  },
  {
    housing: 12,
    number: 9,
    views: ["sea"],
    area: 46,
    layout: "10_46xy",
  },
  {
    housing: 12,
    number: 10,
    views: ["mountains"],
    area: 44.2,
    layout: "9_44.2",
  },
  {
    housing: 12,
    number: 11,
    views: ["sea"],
    area: 39.3,
    layout: "2_39.3x",
  },
  {
    housing: 12,
    number: 12,
    views: ["mountains"],
    area: 22.9,
    layout: "24_22.9",
  },
  //13 корпус
  {
    housing: 13,
    number: 1,
    views: ["sea", "mountains"],
    area: 40.9,
    layout: "2_40.3xr90",
  },
  {
    housing: 13,
    number: 2,
    views: ["mountains"],
    area: 37.8,
    layout: "5_37.8",
  },
  {
    housing: 13,
    number: 3,
    views: ["sea", "mountains"],
    area: 47.9,
    layout: "10_47r90",
  },
  {
    housing: 13,
    number: 4,
    views: ["mountains"],
    area: 47.7,
    layout: "10_47.7xr90",
  },
  {
    housing: 13,
    number: 5,
    views: ["sea", "mountains"],
    area: 60.6,
    layout: "13_60.6xy",
  },
  {
    housing: 13,
    number: 6,
    views: ["mountains"],
    area: 47.9,
    layout: "10_47.9xyr90",
  },
  {
    housing: 13,
    number: 8,
    views: ["mountains"],
    area: 68.1,
    layout: "14_68.1xy",
  },

]

const mainSliderData = {
  complex: {
    title: "Комплекс",
    text: "Комплекс расположен в 40 метрах от моря в центре Адлерского района, из окон открываются непревзойденные виды на морской горизонт.",
    images: [
      "mgallery/complex/1.jpg",
      "mgallery/complex/2.jpg",
      "mgallery/complex/3.jpg",
      "mgallery/complex/4.jpg",
      "mgallery/complex/5.jpg",
      "mgallery/complex/6.jpg",
      "mgallery/complex/7.jpg",
      "mgallery/complex/8.jpg",
      "mgallery/complex/9.jpg",
      "mgallery/complex/10.jpg",
      "mgallery/complex/11.jpg",
      "mgallery/complex/12.jpg",
    ],
  },

  interior: {
    title: "Интерьер",
    text: "Интерьер апарт-отеля GORIZONT - это искусное сочетание роскоши, комфорта и функциональности, создающее уютную и элегантную атмосферу для всех его гостей.",
    images: [
      "mgallery/interior/1.jpg",
      "mgallery/interior/2.jpg",
      "mgallery/interior/3.jpg",
      "mgallery/interior/4.jpg",
    ],
  },

  beaches: {
    title: "Пляжи",
    text: "В 40 метрах от комплекса расположены лучшие пляжи Черноморского побережья, предлагая гостям идеальное место для отдыха и наслаждения солнцем и морским горизонтом.",
    images: [
      "mgallery/beaches/1.jpg",
      "mgallery/beaches/2.jpg",
      "mgallery/beaches/3.jpg",
      "mgallery/beaches/4.jpg",
      "mgallery/beaches/5.jpg",
      "mgallery/beaches/6.jpg",
      "mgallery/beaches/7.jpg",
      "mgallery/beaches/8.jpg",
      "mgallery/beaches/9.jpg",
    ],
  },

  touristCentre: {
    title: "Туристический центр",
    text: "Адлер и Сириус - ключевые туристические центры Сочи. Здесь находятся лучшие пляжи города, самая богатая и разнообразная инфраструктура для отдыха.",
    images: [
      "images/no_img.jpg",
    ],
  },

  restaurants: {
    title: "Рестораны и кафе",
    text: "GORIZONT расположен в центре Адлера, где сосредоточены лучшие рестораны Сочи, предлагая гостям широкий выбор кулинарных впечатлений в непосредственной близости.",
    images: [
      "mgallery/restaurants/1.jpg",
      "mgallery/restaurants/2.jpg",
      "mgallery/restaurants/3.jpg",
      "mgallery/restaurants/4.jpg",
      "mgallery/restaurants/5.jpg",
      "mgallery/restaurants/6.jpg",
      "mgallery/restaurants/7.jpg",
      "mgallery/restaurants/8.jpg",
      "mgallery/restaurants/9.jpg",
      "mgallery/restaurants/10.jpg",
      "mgallery/restaurants/11.jpg",
      "mgallery/restaurants/12.jpg",
      "mgallery/restaurants/13.jpg",
      "mgallery/restaurants/14.jpg",
      "mgallery/restaurants/15.jpg",
      "mgallery/restaurants/16.jpg",
      "mgallery/restaurants/17.jpg",
      "mgallery/restaurants/18.jpg",
      "mgallery/restaurants/19.jpg",
      "mgallery/restaurants/20.jpg",
      "mgallery/restaurants/21.jpg",
      "mgallery/restaurants/22.jpg",
      "mgallery/restaurants/23.jpg",
      "mgallery/restaurants/24.jpg",
      "mgallery/restaurants/25.jpg",
      "mgallery/restaurants/26.jpg",
      "mgallery/restaurants/27.jpg",
      "mgallery/restaurants/28.jpg",
      "mgallery/restaurants/29.jpg",
      "mgallery/restaurants/30.jpg",
      "mgallery/restaurants/31.jpg",
      "mgallery/restaurants/32.jpg",
      "mgallery/restaurants/33.jpg",
      "mgallery/restaurants/34.jpg",
      "mgallery/restaurants/35.jpg",
      "mgallery/restaurants/36.jpg",
      "mgallery/restaurants/37.jpg",
      "mgallery/restaurants/38.jpg",
      "mgallery/restaurants/39.jpg",
      "mgallery/restaurants/40.jpg",
      "mgallery/restaurants/41.jpg",
      "mgallery/restaurants/42.jpg",
      "mgallery/restaurants/43.jpg",
      "mgallery/restaurants/44.jpg",
      "mgallery/restaurants/45.jpg",
      "mgallery/restaurants/46.jpg",
      "mgallery/restaurants/47.jpg",
      "mgallery/restaurants/48.jpg",
      "mgallery/restaurants/49.jpg",
      "mgallery/restaurants/50.jpg"
    ],
  },

  barsClubs: {
    title: "Бары и клубы",
    text: "Всего в 500м от комплекса находится ТРК Мандарин, где можно найти лучшие клубы и бары г. Сочи и провести незабываемый weekend.",
    images: [
      "mgallery/bars_clubs/1.jpg",
      "mgallery/bars_clubs/2.jpg",
      "mgallery/bars_clubs/3.jpg",
      "mgallery/bars_clubs/4.jpg",
      "mgallery/bars_clubs/5.jpg",
      "mgallery/bars_clubs/6.jpg",
      "mgallery/bars_clubs/7.jpg",
      "mgallery/bars_clubs/8.jpg",
      "mgallery/bars_clubs/9.jpg",
      "mgallery/bars_clubs/10.jpg",
      "mgallery/bars_clubs/11.jpg",
      "mgallery/bars_clubs/12.jpg",
      "mgallery/bars_clubs/13.jpg",
      "mgallery/bars_clubs/14.jpg",
      "mgallery/bars_clubs/15.jpg",
      "mgallery/bars_clubs/16.jpg",
    ],
  },

  shoppingMallAndFinance: {
    title: "ТЦ и финансы",
    text: "В центре Адлера большое количество торговых центров и финансовых учреждений.",
    images: [
      "images/no_img.jpg",
    ],
  },

  schoolsAndKindergartens: {
    title: "Школы и д/с",
    text: "В центре Адлера в шаговой доступности большое количество школ и детских садиков.",
    images: [
      "images/no_img.jpg",
    ],
  },

  socialFacilities: {
    title: "Соц. инфраструктура",
    text: "В шаговой доступности от комплекса расположена разнообразная социальная инфраструктура: аптеки, поликлиники, частные клиники, больницы и стационары.",
    images: [
      "images/no_img.jpg",
    ],
  },

  beautyAndHealth: {
    title: "Красота и здоровье",
    text: "В шаговой доступности от комплекса вы сможете найти салоны красоты и эстетической медецины.",
    images: [
      "images/no_img.jpg",
    ],
  },

  supermarkets: {
    title: "Супермаркеты",
    text: "Лучшие супермаркеты, такие как Перекресток, ВкусВилл, Пятерочка, Магнит в шаговой доступности от комплекса.",
    images: [
      "mgallery/supermarkets/1.jpg",
      "mgallery/supermarkets/2.jpg",
      "mgallery/supermarkets/3.jpg",
      "mgallery/supermarkets/4.jpg",
    ],
  }
}

const mainPCSliderImg = [
    "complex_pc/1.jpg",
    "complex_pc/2.jpg",
    "complex_pc/3.jpg",
    "complex_pc/4.jpg",
]

const firstScreenHeaderTextArr = ["вашей мечты", "ярких эмоций", "вашего успеха", "новых возможностей", "будущих открытий"];

const ImageWithProgressWithMemo = React.memo(({src, addClasses}) => {
      const [loading, setLoading] = useState(true);
      //console.log("re-render ImageWithProgressWithMemo src="+src);
      return (
          <div className={clsx("imageWithSpinnerWrapper", addClasses)}>
            <img className="mainSliderImg" src={src} onLoad={() => {setLoading(false)}} style={{ display: loading ? "none" : "block" }}/>
            {loading && <CircularProgress/>}
          </div>
      );
    },
    (b, a) => (!(a.src != b.src))
);

const ApartamentsDataSliderWithMemo = React.memo((props) => {

  const {apartamentsData, onViewPhotosApartament, onViewPriceApartament} = props;

  const [apartDataSwiper, setApartDataSwiper] = React.useState(null);

  //console.log("re-render apartamentsDataSliderWithCallback");

  useEffect(() => {
    //console.log("reset ApartamentsDataSliderWithMemo to 0");
    if(apartDataSwiper) apartDataSwiper.slideTo(0, 0);
  },[apartamentsData]);

  return (
      <Swiper
          speed={1000}
          spaceBetween={14}
          slidesPerView={1.1}
          centeredSlides={true}
          //onSlideChange={(s) => layoutSelect(s)}
          //id="discover_slider"
          onSwiper={(sw) => {
            setApartDataSwiper(sw);
          }}
      >

        {!!apartamentsData.apartaments?.length &&
        apartamentsData.apartaments.map(l => (
            <SwiperSlide key={l.housing+"_"+l.number}>
              <div className="card">

                <div className="apartament_header">Корпус {l.housing}, планировка №{l.number}, {l.area}м², вид: {l.views.map(v => (v == "sea"?"на море":"на горы")).join(", ")}</div>

                <div className="img">
                  <ImageWithProgressWithMemo src={"layouts/"+l.layout+".jpg"} addClasses={"imageWithSpinnerWrapperSquare"}/>
                </div>

                <div className="btns">

                  <button className="btn btn_gallery" onClick={() => onViewPhotosApartament(l.housing, l.number)}>
                    фото
                  </button>

                  <button className="btn btn_price" onClick={() => onViewPriceApartament(l.housing, l.number)}>
                    цены
                  </button>

                </div>
              </div>
            </SwiperSlide>
        ))
        }

      </Swiper>
  )
},(b, a) => {
  return !(a.apartamentsData != b.apartamentsData);
});

const MainPCSliderWithMemo = React.memo((props) => {

    const {mainPCSSwiper, setMainPCSSwiper} = props;

    return (
        <Swiper
            speed={1000}
            spaceBetween={14}
            slidesPerView={1.1}
            centeredSlides={true}
            //onSlideChange={(s) => layoutSelect(s)}
            //id="discover_slider"
            onSwiper={(sw) => {
                setMainPCSSwiper(sw);
            }}
        >
            {
                mainPCSliderImg.map((img, index) => (
                    <SwiperSlide key={index}>
                        <ImageWithProgressWithMemo src={img} addClasses="imageWithSpinnerWrapperH100"/>
                    </SwiperSlide>
                ))
            }
        </Swiper>
    )
},(b, a) => !(a.mainPCSSwiper != b.mainPCSSwiper));


const MainSliderWithMemo = React.memo((props) => {

  const {mainSwiper, setMainSwiper, images, category} = props;

  //console.log("re-render MainSliderWithMemo");

  useEffect(() => {
    //console.log("reset MainSliderWithMemo to 0");
    if(mainSwiper) mainSwiper.slideTo(0, 0);
  },[images]);

  return (
      <Swiper
          className="mainSliderWrapper"
          speed={1000}
          modules={[Pagination]}
          spaceBetween={1}
          slidesPerView={1}
          pagination={{ clickable: true, dynamicBullets: true, dynamicMainBullets: 10 }}
          onSwiper={(sw) => {setMainSwiper(sw)}}
          id="discover_slider"
      >

        <button className="control_btn l_btn" onClick={() => !!mainSwiper && mainSwiper.slidePrev()}>
          <SvgArrowLeft />
        </button>

        <button className="control_btn r_btn" onClick={() => !!mainSwiper && mainSwiper.slideNext()}>
          <SvgArrowRight />
        </button>

        {
          images.map((img, index) => {
            return (
                <SwiperSlide key={index+"_"+category}>
                  <ImageWithProgressWithMemo src={img} addClasses={"imageWithSpinnerWrapperMainSlider imageWithSpinnerWrapperSquare"} />
                </SwiperSlide>
            );
          })
        }

      </Swiper>
  )
},(b, a) => {
  //console.log("need re-render "+(a.images != b.images || a.mainSwiper != b.mainSwiper));
  return !(a.images != b.images || a.mainSwiper != b.mainSwiper);
});

//преобразуем объект в массив
const mainSliderDataArr = Object.keys(mainSliderData).map((key, index) => ({id: key, index, title: mainSliderData[key].title, text: mainSliderData[key].text }));

const Main = () => {

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    setWindowDimensions({width: (width > 500?500:width), height});
  };

  const [mainSwiper, setMainSwiper] = React.useState(null);
  const [mainSliderActiveCat, setMainSliderActiveCat] = React.useState("complex");
  const [mainSliderImages, setMainSliderImages] = React.useState(mainSliderData["complex"].images);
  const [apartment_swiper, setApartmentSwiper] = React.useState(null);
  const [mainPCSSwiper, setMainPCSSwiper] = React.useState(null);
  const [investment_slider, setInvestment_slider] = useState(null);
  const [windowDimensions, setWindowDimensions] = useState({});
  const [toast, setToast] = useState({open: false, severity: "error", "text": ""});
  const [firstScreenHeaderTextIndex, setFirstScreenHeaderTextIndex] = useState(0);
  const [showVideo, setShowVideo] = useState(false);
  //для анимации мигания рамки
  const [apartamentsBlinkHouse, setApartamentsBlinkHouse] = useState(1);

  const [apartamentsData, setApartamentsData] = useState({
    activeTab: "housing",
    housing: null,
    view: null,
    availableSeaView: true,
    availableMountainsView: true,
    apartaments: [],
  });


  //Drawer NotSw
  const [drawerNotSw, setDrawerNotSw] = useState({
    show: false,
    height: "drawerFs",
    type: null,
    zIndex: 1205,
  });


  useEffect(() => {

    const location = document.getElementById("location");
    const map = document.querySelector("#location #map .flags");

    disablePinchZoom();
    getWindowDimensions();

    window.addEventListener('resize', getWindowDimensions);

    window.addEventListener("scroll", () => {
      if (window.scrollY + window.innerHeight / 2 > location.offsetTop) {
        map.classList.add("flags_on");
      }
    });

    //смена H1
    const intervalH1 = setInterval(() => {
      let firstScreenHeaderTextIndexVarTmp = (firstScreenHeaderTextIndexVar + 1) > (firstScreenHeaderTextArr.length - 1)?0:(firstScreenHeaderTextIndexVar + 1);
      firstScreenHeaderTextIndexVar = firstScreenHeaderTextIndexVarTmp;
      setFirstScreenHeaderTextIndex(firstScreenHeaderTextIndexVar);
    }, 4500);

    //мигание рамки корпусов
    const intervalApartBlink = setInterval(() => {
      if(!apartamentsData.housing){
        let apartamentsBlinkHouseVarTmp = randomInteger(1,13);
        //let apartamentsBlinkHouseVarTmp = (apartamentsBlinkHouseVar + 1) > 13?1:(apartamentsBlinkHouseVar + 1);
        apartamentsBlinkHouseVar = apartamentsBlinkHouseVarTmp;
        setApartamentsBlinkHouse(apartamentsBlinkHouseVarTmp);
      }else{
        apartamentsBlinkHouseVar = null;
        setApartamentsBlinkHouse(null);
      }
    }, 1500);

    return () => {
      clearInterval(intervalH1);
      clearInterval(intervalApartBlink);
    }

  }, []);


  function invSliding(i) {
    investment_slider.slideTo(i);
    const btns = document.querySelectorAll(".investment .tabs .btn");
    btns.forEach((el) => el.classList.remove("active"));
    btns[i].classList.add("active");
  }

  // modalVideo
  const videoRef = useRef(null);

  const replayVideo = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
    }
  };

  const stopPauseVideo = () => {
    if(videoRef?.current?.paused){
      videoRef.current.play();
    }else{
      !!videoRef?.current && videoRef.current.pause();
    }
  };

  const pauseVideo = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  // modalRequest
  function toggleRequestModal() {
    const modal = document.getElementById("request_modal");
    const overlay = document.querySelector(".pc .overlay");
    modal.classList.toggle("modal_active");
    overlay.classList.toggle("overlay_active");
  }

  /////

  const getApartaments = ({housing, view}) => {
    if(!(housing)) return [];
    if(!view){
      return layoutsData.filter(l => l.housing == housing);
    }
    return layoutsData.filter(l => l.housing == housing && l.views.indexOf(view) > -1);
  };

  const housingSvgData = [
    {
      id: 1,
      border: <path data-id="border" d="M95.0423 98.7941L107.893 124.107L96.1073 130.015L97.4763 132.777L41.1844 160.436L37.4136 152.29L40.5925 150.705L38.2731 145.794L24.967 152.226L16.0898 133.436L81.5314 101.635L83.1189 104.779L95.0423 98.7941Z" stroke="#C3C7CD" strokeWidth="2"/>,
      number: <path data-id="1" d="M63.9624 132.692C63.9624 133.284 64.0104 133.732 64.1064 134.036C64.2184 134.324 64.4424 134.516 64.7784 134.612C65.1304 134.708 65.6584 134.764 66.3624 134.78V135.332H57.9624V134.78C58.6824 134.764 59.2104 134.708 59.5464 134.612C59.8984 134.516 60.1224 134.324 60.2184 134.036C60.3144 133.732 60.3624 133.284 60.3624 132.692V126.908L58.1544 128.3L57.6504 127.532L62.9784 124.052H64.1304C64.0664 124.356 64.0184 124.66 63.9864 124.964C63.9704 125.268 63.9624 125.572 63.9624 125.876V132.692Z" fill="#8A929C"/>,
      bg: <path data-id="bg-1" d="M94.8899 98.5671L107.741 123.88L95.9549 129.788L97.324 132.55L41.0321 160.209L37.2612 152.063L40.4402 150.478L38.1208 145.567L24.8146 151.999L15.9375 133.208L81.3791 101.408L82.9666 104.552L94.8899 98.5671Z" fill="#EFF0F2"/>,
    },
    {
      id: 2,
      border: <path data-id="border" d="M135.79 116.986L133.273 112.126L149.112 103.988L135.395 76.6669L119.283 84.4857L116.2 78.345L121.942 75.4506L119.508 70.6214L122.52 69.1866L105.553 33.6581L97.7273 37.2956L99.3613 40.8309L93.0411 43.8629L85.8474 29.1483L67.6357 38.094L89.313 84.7198L93.3008 82.9971L98.2181 93.5475L102.931 91.3251L105.734 96.9999L96.3673 101.402L107.89 124.104L111.656 122.184L115.896 129.465L135.79 116.986Z" stroke="#C3C7CD" strokeWidth="2"/>,
      number: <path data-id="2" d="M105.269 66.1318H105.821L105.581 70.3318H95.6934V69.7798C95.8374 69.6998 96.0374 69.5798 96.2934 69.4198C96.5654 69.2438 96.8294 69.0678 97.0854 68.8918C97.9814 68.2518 98.6854 67.6358 99.1974 67.0438C99.7254 66.4518 100.117 65.8998 100.373 65.3878C100.629 64.8598 100.789 64.3958 100.853 63.9958C100.933 63.5798 100.973 63.2518 100.973 63.0118C100.973 62.5478 100.837 62.1718 100.565 61.8838C100.309 61.5958 99.8774 61.4518 99.2694 61.4518C98.7414 61.4518 98.2534 61.5878 97.8054 61.8598C97.3574 62.1158 96.8614 62.5478 96.3174 63.1558L95.8614 62.7718C96.4054 61.5878 97.1334 60.6518 98.0454 59.9638C98.9574 59.2758 100.069 58.9318 101.381 58.9318C102.517 58.9318 103.373 59.1958 103.949 59.7238C104.525 60.2358 104.813 60.9558 104.813 61.8838C104.813 63.0838 104.405 64.1238 103.589 65.0038C102.773 65.8678 101.693 66.6598 100.349 67.3798V67.4518H102.749C103.661 67.4518 104.293 67.3398 104.645 67.1158C104.997 66.8758 105.205 66.5478 105.269 66.1318Z" fill="#8A929C"/>,
      bg: <path data-id="bg-2" d="M135.638 116.759L133.121 111.899L148.959 103.761L135.243 76.4399L119.13 84.2587L116.048 78.118L121.79 75.2236L119.356 70.3944L122.368 68.9596L105.4 33.4311L97.575 37.0686L99.209 40.6039L92.8888 43.6359L85.6951 28.9212L67.4834 37.867L89.1607 84.4928L93.1484 82.7701L98.0657 93.3205L102.779 91.0981L105.581 96.7729L96.2149 101.175L107.738 123.877L111.504 121.957L115.743 129.238L135.638 116.759Z" fill="#EFF0F2"/>
    },
    {
      id: 3,
      border: <path data-id="border" d="M152.609 202.425L136.562 179.302L127.147 185.28L125.141 182.27L71.7542 215.19L76.6419 222.719L79.6757 220.873L82.5974 225.451L70.0684 233.288L81.2475 250.808L143.089 211.608L141.518 209.351L152.609 202.425Z" stroke="#C3C7CD" strokeWidth="2"/>,
      number: <path data-id="3" d="M109.69 212.3V212.372C110.202 212.372 110.762 212.452 111.37 212.612C111.978 212.756 112.554 212.996 113.098 213.332C113.642 213.668 114.09 214.116 114.442 214.676C114.794 215.22 114.97 215.884 114.97 216.668C114.97 217.484 114.77 218.228 114.37 218.9C113.97 219.572 113.434 220.14 112.762 220.604C112.09 221.084 111.33 221.452 110.482 221.708C109.634 221.964 108.754 222.092 107.842 222.092C107.426 222.092 106.946 222.052 106.402 221.972C105.858 221.908 105.322 221.788 104.794 221.612C104.266 221.436 103.794 221.188 103.378 220.868C103.506 219.812 103.858 218.908 104.434 218.156C104.962 219.1 105.53 219.82 106.138 220.316C106.746 220.812 107.402 221.06 108.106 221.06C108.794 221.06 109.354 220.876 109.786 220.508C110.234 220.14 110.57 219.66 110.794 219.068C111.018 218.492 111.13 217.892 111.13 217.268C111.13 215.956 110.658 215.028 109.714 214.484C108.77 213.924 107.49 213.86 105.874 214.292V213.38C106.946 212.996 107.786 212.572 108.394 212.108C109.002 211.628 109.434 211.14 109.69 210.644C109.946 210.148 110.074 209.692 110.074 209.276C110.074 208.7 109.922 208.252 109.618 207.932C109.314 207.612 108.842 207.452 108.202 207.452C107.658 207.452 107.09 207.604 106.498 207.908C105.906 208.212 105.306 208.708 104.698 209.396L104.242 209.012C104.594 208.26 105.026 207.58 105.538 206.972C106.066 206.348 106.698 205.852 107.434 205.484C108.17 205.116 109.026 204.932 110.002 204.932C111.138 204.932 112.05 205.196 112.738 205.724C113.442 206.236 113.794 206.972 113.794 207.932C113.794 208.46 113.658 208.996 113.386 209.54C113.13 210.084 112.698 210.596 112.09 211.076C111.498 211.556 110.698 211.964 109.69 212.3Z" fill="#8A929C"/>,
      bg: <path data-id="bg-3" d="M152.457 202.198L136.41 179.075L126.995 185.053L124.988 182.043L71.6019 214.963L76.4896 222.492L79.5234 220.646L82.445 225.224L69.916 233.061L81.0952 250.581L142.936 211.381L141.365 209.124L152.457 202.198Z" fill="#EFF0F2"/>
    },
    {
      id: 4,
      border: <path data-id="border" d="M115.917 129.496L140.301 114.246L146.792 125.156L150.211 123.04L162.231 142.972L158.4 145.638L163.913 154.319L158.33 158.204L161.688 163.536L176.536 153.204L174.862 150.798L183.8 144.578L195.889 161.95L207.768 153.684L215.723 165.117L193.719 180.429L191.136 176.718L176.348 187.008L179.633 191.73L159.411 205.803L155.609 200.339L152.61 202.426L139.24 183.213L149.128 176.332L142.526 166.337L138.785 168.942L133.447 160.006L131.22 161.556L117.871 140.917L121.643 138.293L115.917 129.496Z" stroke="#C3C7CD" strokeWidth="2"/>,
      number: <path data-id="4" d="M138.945 147.452H142.665V143.084H142.593L138.945 147.452ZM146.073 155.732L142.521 156.092C142.553 155.42 142.585 154.588 142.617 153.596C142.649 152.604 142.665 151.516 142.665 150.332H135.513V149.78C135.737 149.572 135.937 149.364 136.113 149.156C136.289 148.948 136.457 148.74 136.617 148.532L143.793 139.988C143.985 139.764 144.169 139.532 144.345 139.292C144.537 139.052 144.721 138.788 144.897 138.5H146.049L146.025 147.452H147.705V150.332H146.697C146.441 150.332 146.265 150.42 146.169 150.596C146.073 150.772 146.025 151.004 146.025 151.292C146.025 152.028 146.025 152.772 146.025 153.524C146.041 154.276 146.057 155.012 146.073 155.732Z" fill="#8A929C"/>,
      bg: <path data-id="bg-4" d="M115.765 129.269L140.149 114.019L146.639 124.929L150.059 122.813L162.079 142.745L158.248 145.411L163.761 154.092L158.178 157.977L161.536 163.309L176.384 152.977L174.71 150.571L183.648 144.351L195.737 161.723L207.615 153.457L215.571 164.89L193.567 180.202L190.984 176.491L176.196 186.781L179.481 191.503L159.259 205.576L155.457 200.112L152.458 202.199L139.088 182.986L148.975 176.105L142.374 166.11L138.632 168.715L133.295 159.778L131.068 161.329L117.719 140.69L121.491 138.066L115.765 129.269Z" fill="#EFF0F2"/>
    },

    {
      id: 5,
      border: <path data-id="border" d="M200.597 275.565L184.55 252.441L174.073 259.996L171.942 256.808L121.324 294.148L126.211 301.678L129.245 299.83L132.332 304.647L121.759 312.887L133.472 330.035L191.969 285.712L190.399 283.456L200.597 275.565Z" stroke="#C3C7CD" strokeWidth="2"/>,
      number: <path data-id="5" d="M165.363 279.172L164.955 282.412H157.563L157.395 283.852C160.131 284.3 162.195 285.052 163.587 286.108C164.979 287.164 165.675 288.492 165.675 290.092C165.675 291.276 165.371 292.316 164.763 293.212C164.171 294.124 163.363 294.828 162.339 295.324C161.331 295.836 160.211 296.092 158.979 296.092C158.371 296.092 157.667 296.004 156.867 295.828C156.083 295.652 155.387 295.332 154.779 294.868C154.907 293.812 155.259 292.908 155.835 292.156C156.331 293.036 156.883 293.74 157.491 294.268C158.115 294.796 158.771 295.06 159.459 295.06C160.467 295.06 161.211 294.748 161.691 294.124C162.187 293.5 162.435 292.772 162.435 291.94C162.435 290.596 161.899 289.524 160.827 288.724C159.755 287.924 158.115 287.38 155.907 287.092L156.939 279.292H163.539C163.923 279.292 164.259 279.284 164.547 279.268C164.851 279.252 165.123 279.22 165.363 279.172Z" fill="#8A929C"/>,
      bg: <path data-id="bg-5" d="M200.445 275.338L184.398 252.214L173.921 259.769L171.79 256.581L121.172 293.921L126.059 301.451L129.093 299.603L132.18 304.42L121.607 312.66L133.319 329.808L191.816 285.485L190.246 283.229L200.445 275.338Z" fill="#EFF0F2"/>
    },
    {
      id: 6,
      border: <path data-id="border" d="M159.412 205.802L183.436 189.084L189.966 198.467L192.757 196.524L205.616 215.256L202.943 217.116L209.322 226.472L203.977 230.192L207.035 234.587L212.381 230.867L228.836 254.324L224.533 257.451L227.199 261.281L208.504 275.966L205.49 271.76L200.678 275.55L186.75 255.536L195.629 249.357L189.367 240.359L185.566 243.004L179.098 233.71L176.603 235.446L163.419 216.5L165.736 214.888L159.412 205.802Z" stroke="#C3C7CD" strokeWidth="2"/>,
      number: <path data-id="6" d="M190.715 211.492C186.699 212.996 184.691 216.124 184.691 220.876C184.691 221.98 184.787 222.972 184.979 223.852C185.171 224.716 185.435 225.404 185.771 225.916C186.123 226.412 186.523 226.66 186.971 226.66C187.563 226.66 188.043 226.236 188.411 225.388C188.795 224.54 188.987 223.46 188.987 222.148C188.987 220.868 188.803 219.924 188.435 219.316C188.067 218.692 187.555 218.38 186.899 218.38C186.739 218.38 186.563 218.396 186.371 218.428C186.195 218.46 186.035 218.516 185.891 218.596L185.507 218.212C185.875 217.828 186.291 217.524 186.755 217.3C187.235 217.06 187.803 216.94 188.459 216.94C189.691 216.94 190.707 217.356 191.507 218.188C192.307 219.004 192.707 220.172 192.707 221.692C192.707 222.732 192.523 223.628 192.155 224.38C191.787 225.132 191.299 225.756 190.691 226.252C190.083 226.732 189.427 227.092 188.723 227.332C188.019 227.572 187.331 227.692 186.659 227.692C185.667 227.692 184.723 227.444 183.827 226.948C182.947 226.436 182.227 225.684 181.667 224.692C181.123 223.7 180.851 222.484 180.851 221.044C180.851 219.684 181.107 218.436 181.619 217.3C182.147 216.148 182.859 215.132 183.755 214.252C184.667 213.356 185.715 212.612 186.899 212.02C188.099 211.428 189.371 211.012 190.715 210.772V211.492Z" fill="#8A929C"/>,
      bg: <path data-id="bg-6" d="M159.259 205.575L183.283 188.857L189.813 198.24L192.605 196.297L205.463 215.029L202.79 216.889L209.169 226.245L203.825 229.965L206.883 234.36L212.228 230.64L228.684 254.096L224.381 257.224L227.047 261.054L208.352 275.739L205.337 271.533L200.525 275.323L186.597 255.309L195.476 249.13L189.215 240.132L185.414 242.777L178.945 233.483L176.451 235.219L163.267 216.273L165.583 214.661L159.259 205.575Z" fill="#EFF0F2"/>
    },
    {
      id: 7,
      border: <path data-id="border" d="M223.068 223.3L212.342 230.941L228.745 254.258L240.458 245.754L242.463 248.634L283.059 218.047L268.918 201.971L261.494 207.579L265.358 213.132L261.289 215.963L253.912 205.362L255.901 203.977L251.48 197.623L220.857 220.123L223.068 223.3Z" stroke="#C3C7CD" strokeWidth="2"/>,
      number: <path data-id="7" d="M249.355 222.292V222.844C249.051 223.436 248.699 224.212 248.299 225.172C247.899 226.116 247.483 227.172 247.051 228.34C246.619 229.492 246.211 230.684 245.827 231.916C245.443 233.148 245.107 234.348 244.819 235.516C244.531 236.7 244.331 237.772 244.219 238.732H239.899C240.715 237.132 241.555 235.596 242.419 234.124C243.299 232.668 244.131 231.228 244.915 229.804C245.699 228.364 246.363 226.9 246.907 225.412H241.075C240.307 225.412 239.787 225.572 239.515 225.892C239.259 226.196 239.099 226.676 239.035 227.332H238.483V222.292H249.355Z" fill="#8A929C"/>,
      bg: <path data-id="bg-7" d="M222.916 223.073L212.19 230.714L228.593 254.031L240.306 245.527L242.31 248.407L282.906 217.82L268.766 201.744L261.341 207.352L265.206 212.905L261.137 215.736L253.76 205.135L255.749 203.75L251.327 197.396L220.705 219.896L222.916 223.073Z" fill="#EFF0F2"/>
    },
    {
      id: 8,
      border: <path data-id="border" d="M256.81 344.432L238.043 321.835L228.391 330.006L226.507 327.614L179.588 368.244L184.749 375.407L187.659 373.381L191.19 378.329L180.394 387.517L192.82 404.169L248.695 355.191L246.9 352.738L256.81 344.432Z" stroke="#C3C7CD" strokeWidth="2"/>,
      number: <path data-id="8" d="M221.264 363.132C221.264 364.172 221 365.036 220.472 365.724C219.96 366.396 219.272 366.892 218.408 367.212C217.544 367.532 216.6 367.692 215.576 367.692C214.648 367.692 213.784 367.564 212.984 367.308C212.184 367.036 211.536 366.628 211.04 366.084C210.544 365.54 210.296 364.86 210.296 364.044C210.296 363.372 210.456 362.796 210.776 362.316C211.112 361.82 211.536 361.412 212.048 361.092C212.56 360.772 213.112 360.532 213.704 360.372C212.664 359.684 211.832 358.98 211.208 358.26C210.6 357.54 210.296 356.644 210.296 355.572C210.296 354.58 210.544 353.748 211.04 353.076C211.552 352.404 212.24 351.892 213.104 351.54C213.984 351.188 214.96 351.012 216.032 351.012C216.896 351.012 217.728 351.132 218.528 351.372C219.328 351.612 219.984 351.996 220.496 352.524C221.008 353.036 221.264 353.716 221.264 354.564C221.264 355.268 221.088 355.884 220.736 356.412C220.384 356.94 219.928 357.388 219.368 357.756C218.824 358.108 218.264 358.372 217.688 358.548C218.568 359.124 219.264 359.644 219.776 360.108C220.304 360.556 220.68 361.012 220.904 361.476C221.144 361.94 221.264 362.492 221.264 363.132ZM213.776 354.516C213.776 354.932 213.864 355.3 214.04 355.62C214.216 355.94 214.52 356.276 214.952 356.628C215.384 356.964 215.976 357.388 216.728 357.9C217.144 357.436 217.448 356.916 217.64 356.34C217.832 355.764 217.928 355.196 217.928 354.636C217.928 353.948 217.776 353.348 217.472 352.836C217.168 352.308 216.656 352.044 215.936 352.044C215.2 352.044 214.656 352.3 214.304 352.812C213.952 353.324 213.776 353.892 213.776 354.516ZM213.776 363.876C213.776 364.708 213.944 365.38 214.28 365.892C214.616 366.404 215.072 366.66 215.648 366.66C216.208 366.66 216.68 366.436 217.064 365.988C217.464 365.54 217.664 365.012 217.664 364.404C217.664 363.668 217.368 363.044 216.776 362.532C216.184 362.004 215.496 361.492 214.712 360.996C214.296 361.492 214.032 362.02 213.92 362.58C213.824 363.124 213.776 363.556 213.776 363.876Z" fill="#8A929C"/>,
      bg: <path data-id="bg-8" d="M256.657 344.205L237.891 321.608L228.239 329.779L226.354 327.387L179.436 368.017L184.596 375.18L187.507 373.154L191.038 378.102L180.242 387.29L192.667 403.942L248.543 354.964L246.747 352.511L256.657 344.205Z" fill="#EFF0F2"/>
    },
    {
      id: 9,
      border: <path data-id="border" d="M209.46 275.124L232.279 257.437L239.636 266.995L242.363 264.833L256.284 283.001L254.133 284.85L260.7 294.033L255.703 298.127L259.431 302.85L264.724 298.548L283.121 320.742L278.915 324.197L282.264 328.125L264.54 344.647L261.332 340.797L256.898 344.368L240.618 324.712L248.611 317.387L242.294 309.132L237.732 312.837L230.719 303.392L228.224 305.128L214.671 286.792L216.987 285.181L209.46 275.124Z" stroke="#C3C7CD" strokeWidth="2"/>,
      number: <path data-id="9" d="M234.675 298.612C236.227 298.1 237.451 297.332 238.347 296.308C239.243 295.3 239.883 294.132 240.267 292.804C240.667 291.476 240.867 290.076 240.867 288.604C240.867 286.892 240.651 285.524 240.219 284.5C239.803 283.476 239.267 282.964 238.611 282.964C238.211 282.964 237.851 283.172 237.531 283.588C237.227 283.988 236.987 284.54 236.811 285.244C236.651 285.932 236.571 286.716 236.571 287.596C236.571 288.876 236.755 289.884 237.123 290.62C237.491 291.356 238.011 291.724 238.683 291.724C238.827 291.724 238.987 291.708 239.163 291.676C239.355 291.628 239.523 291.572 239.667 291.508L240.051 291.892C239.699 292.276 239.283 292.588 238.803 292.828C238.323 293.052 237.779 293.164 237.171 293.164C236.323 293.164 235.571 292.932 234.915 292.468C234.275 291.988 233.771 291.348 233.403 290.548C233.035 289.732 232.851 288.82 232.851 287.812C232.851 286.772 233.035 285.884 233.403 285.148C233.771 284.396 234.259 283.788 234.867 283.324C235.475 282.844 236.139 282.492 236.859 282.268C237.579 282.044 238.283 281.932 238.971 281.932C239.947 281.932 240.867 282.164 241.731 282.628C242.611 283.092 243.323 283.804 243.867 284.764C244.427 285.708 244.707 286.916 244.707 288.388C244.707 289.732 244.459 291.012 243.963 292.228C243.483 293.428 242.787 294.516 241.875 295.492C240.979 296.484 239.923 297.308 238.707 297.964C237.491 298.636 236.147 299.092 234.675 299.332V298.612Z" fill="#8A929C"/>,
      bg: <path data-id="bg-9" d="M209.307 274.897L232.127 257.21L239.483 266.768L242.21 264.606L256.132 282.774L253.981 284.623L260.547 293.806L255.551 297.9L259.278 302.622L264.572 298.321L282.969 320.515L278.762 323.97L282.112 327.898L264.388 344.42L261.18 340.57L256.745 344.141L240.466 324.485L248.459 317.16L242.142 308.905L237.579 312.61L230.566 303.165L228.072 304.901L214.518 286.565L216.835 284.954L209.307 274.897Z" fill="#EFF0F2"/>
    },
    {
      id: 10,
      border: <path data-id="border" d="M273.885 288.975L263.728 297.307L275.009 310.92L276.981 309.195L284.508 318.237L293.928 310.493L295.96 312.78L344.482 271.765L329.519 256.353L322.424 262.38L326.559 267.735L322.637 270.765L314.742 260.543L316.66 259.061L311.928 252.934L271.519 285.912L273.885 288.975Z" stroke="#C3C7CD" strokeWidth="2"/>,
      number: <path data-id="10" d="M296.575 287.692C296.575 288.284 296.623 288.732 296.719 289.036C296.831 289.324 297.055 289.516 297.391 289.612C297.743 289.708 298.271 289.764 298.975 289.78V290.332H290.575V289.78C291.295 289.764 291.823 289.708 292.159 289.612C292.511 289.516 292.735 289.324 292.831 289.036C292.927 288.732 292.975 288.284 292.975 287.692V281.908L290.767 283.3L290.263 282.532L295.591 279.052H296.743C296.679 279.356 296.631 279.66 296.599 279.964C296.583 280.268 296.575 280.572 296.575 280.876V287.692ZM306.091 278.932C307.035 278.932 307.923 279.172 308.755 279.652C309.587 280.116 310.259 280.78 310.771 281.644C311.299 282.508 311.563 283.54 311.563 284.74C311.563 285.94 311.299 286.988 310.771 287.884C310.259 288.764 309.579 289.452 308.731 289.948C307.883 290.444 306.971 290.692 305.995 290.692C305.051 290.692 304.163 290.46 303.331 289.996C302.499 289.516 301.819 288.844 301.291 287.98C300.779 287.1 300.523 286.06 300.523 284.86C300.523 283.66 300.779 282.62 301.291 281.74C301.819 280.844 302.507 280.156 303.355 279.676C304.203 279.18 305.115 278.932 306.091 278.932ZM306.115 287.212C307.555 287.212 308.619 286.956 309.307 286.444C310.011 285.932 310.363 285.38 310.363 284.788C310.363 284.148 309.987 283.596 309.235 283.132C308.499 282.652 307.411 282.412 305.971 282.412C304.547 282.412 303.483 282.652 302.779 283.132C302.075 283.596 301.723 284.132 301.723 284.74C301.723 285.38 302.099 285.956 302.851 286.468C303.603 286.964 304.691 287.212 306.115 287.212Z" fill="#8A929C"/>,
      bg: <path data-id="bg-10" d="M273.733 288.748L263.575 297.08L274.857 310.693L276.829 308.968L284.356 318.01L293.775 310.265L295.808 312.553L344.33 271.538L329.366 256.126L322.271 262.153L326.407 267.508L322.484 270.538L314.59 260.316L316.508 258.834L311.776 252.707L271.366 285.685L273.733 288.748Z" fill="#EFF0F2"/>
    },
    {
      id: 11,
      border: <path data-id="border" d="M298.895 389.303L319.667 409.625L310.234 419.087L312.413 421.214L268.845 466.026L262.268 460.137L264.59 457.458L260.044 453.423L249.766 463.187L234.521 449.07L287.337 396.234L289.586 398.278L298.895 389.303Z" stroke="#C3C7CD" strokeWidth="2"/>,
      number: <path data-id="11" d="M276.7 431.692C276.7 432.284 276.748 432.732 276.844 433.036C276.956 433.324 277.18 433.516 277.516 433.612C277.868 433.708 278.396 433.764 279.1 433.78V434.332H270.7V433.78C271.42 433.764 271.948 433.708 272.284 433.612C272.636 433.516 272.86 433.324 272.956 433.036C273.052 432.732 273.1 432.284 273.1 431.692V425.908L270.892 427.3L270.388 426.532L275.716 423.052H276.868C276.804 423.356 276.756 423.66 276.724 423.964C276.708 424.268 276.7 424.572 276.7 424.876V431.692ZM287.224 431.692C287.224 432.284 287.272 432.732 287.368 433.036C287.48 433.324 287.704 433.516 288.04 433.612C288.392 433.708 288.92 433.764 289.624 433.78V434.332H281.224V433.78C281.944 433.764 282.472 433.708 282.808 433.612C283.16 433.516 283.384 433.324 283.48 433.036C283.576 432.732 283.624 432.284 283.624 431.692V425.908L281.416 427.3L280.912 426.532L286.24 423.052H287.392C287.328 423.356 287.28 423.66 287.248 423.964C287.232 424.268 287.224 424.572 287.224 424.876V431.692Z" fill="#8A929C"/>,
      bg: <path data-id="bg-11" d="M298.742 389.075L319.514 409.398L310.082 418.86L312.26 420.987L268.693 465.799L262.116 459.91L264.437 457.231L259.891 453.196L249.614 462.96L234.368 448.843L287.184 396.007L289.434 398.051L298.742 389.075Z" fill="#EFF0F2"/>
    },
    {
      id: 12,
      border: <path data-id="border" d="M264.594 344.582L286.746 324.058L295.315 333.377L297.8 331.055L314.615 348.765L312.368 350.858L319.956 359.104L315.207 363.996L319.776 368.608L324.803 363.532L345.499 383.774L337.402 392.406L333.244 388.468L324.45 397.672L328.445 401.768L320.304 410.299L302.351 392.644L310.394 384.314L302.672 376.687L298.838 380.34L290.67 372.126L288.45 374.201L271.935 356.345L273.997 354.418L264.594 344.582Z" stroke="#C3C7CD" strokeWidth="2"/>,
      number: <path data-id="12" d="M289.079 354.692C289.079 355.284 289.127 355.732 289.223 356.036C289.335 356.324 289.559 356.516 289.895 356.612C290.247 356.708 290.775 356.764 291.479 356.78V357.332H283.079V356.78C283.799 356.764 284.327 356.708 284.663 356.612C285.015 356.516 285.239 356.324 285.335 356.036C285.431 355.732 285.479 355.284 285.479 354.692V348.908L283.271 350.3L282.767 349.532L288.095 346.052H289.247C289.183 346.356 289.135 346.66 289.103 346.964C289.087 347.268 289.079 347.572 289.079 347.876V354.692ZM302.531 353.132H303.083L302.843 357.332H292.955V356.78C293.099 356.7 293.299 356.58 293.555 356.42C293.827 356.244 294.091 356.068 294.347 355.892C295.243 355.252 295.947 354.636 296.459 354.044C296.987 353.452 297.379 352.9 297.635 352.388C297.891 351.86 298.051 351.396 298.115 350.996C298.195 350.58 298.235 350.252 298.235 350.012C298.235 349.548 298.099 349.172 297.827 348.884C297.571 348.596 297.139 348.452 296.531 348.452C296.003 348.452 295.515 348.588 295.067 348.86C294.619 349.116 294.123 349.548 293.579 350.156L293.123 349.772C293.667 348.588 294.395 347.652 295.307 346.964C296.219 346.276 297.331 345.932 298.643 345.932C299.779 345.932 300.635 346.196 301.211 346.724C301.787 347.236 302.075 347.956 302.075 348.884C302.075 350.084 301.667 351.124 300.851 352.004C300.035 352.868 298.955 353.66 297.611 354.38V354.452H300.011C300.923 354.452 301.555 354.34 301.907 354.116C302.259 353.876 302.467 353.548 302.531 353.132Z" fill="#8A929C"/>,
      bg: <path data-id="bg-12" d="M264.441 344.355L286.594 323.831L295.163 333.15L297.647 330.828L314.462 348.538L312.215 350.631L319.804 358.877L315.054 363.769L319.624 368.381L324.65 363.305L345.346 383.547L337.249 392.179L333.091 388.24L324.297 397.445L328.293 401.541L320.151 410.071L302.198 392.417L310.242 384.087L302.52 376.46L298.685 380.113L290.518 371.899L288.298 373.974L271.783 356.118L273.845 354.191L264.441 344.355Z" fill="#EFF0F2"/>
    },
    {
      id: 13,
      border: <path data-id="border" d="M356.272 373.986L346.28 384.47L324.752 363.526L334.627 353.965L332.032 351.187L360.274 322.248L374.474 338.204L368.073 344.916L363.025 340.412L359.725 344.11L368.941 352.737L370.792 350.763L376.478 356.421L358.457 375.996L356.272 373.986Z" stroke="#C3C7CD" strokeWidth="2"/>,
      number: <path data-id="13" d="M345.868 359.692C345.868 360.284 345.916 360.732 346.012 361.036C346.124 361.324 346.348 361.516 346.684 361.612C347.036 361.708 347.564 361.764 348.268 361.78V362.332H339.868V361.78C340.588 361.764 341.116 361.708 341.452 361.612C341.804 361.516 342.028 361.324 342.124 361.036C342.22 360.732 342.268 360.284 342.268 359.692V353.908L340.06 355.3L339.556 354.532L344.884 351.052H346.036C345.972 351.356 345.924 351.66 345.892 351.964C345.876 352.268 345.868 352.572 345.868 352.876V359.692ZM354.952 358.3V358.372C355.464 358.372 356.024 358.452 356.632 358.612C357.24 358.756 357.816 358.996 358.36 359.332C358.904 359.668 359.352 360.116 359.704 360.676C360.056 361.22 360.232 361.884 360.232 362.668C360.232 363.484 360.032 364.228 359.632 364.9C359.232 365.572 358.696 366.14 358.024 366.604C357.352 367.084 356.592 367.452 355.744 367.708C354.896 367.964 354.016 368.092 353.104 368.092C352.688 368.092 352.208 368.052 351.664 367.972C351.12 367.908 350.584 367.788 350.056 367.612C349.528 367.436 349.056 367.188 348.64 366.868C348.768 365.812 349.12 364.908 349.696 364.156C350.224 365.1 350.792 365.82 351.4 366.316C352.008 366.812 352.664 367.06 353.368 367.06C354.056 367.06 354.616 366.876 355.048 366.508C355.496 366.14 355.832 365.66 356.056 365.068C356.28 364.492 356.392 363.892 356.392 363.268C356.392 361.956 355.92 361.028 354.976 360.484C354.032 359.924 352.752 359.86 351.136 360.292V359.38C352.208 358.996 353.048 358.572 353.656 358.108C354.264 357.628 354.696 357.14 354.952 356.644C355.208 356.148 355.336 355.692 355.336 355.276C355.336 354.7 355.184 354.252 354.88 353.932C354.576 353.612 354.104 353.452 353.464 353.452C352.92 353.452 352.352 353.604 351.76 353.908C351.168 354.212 350.568 354.708 349.96 355.396L349.504 355.012C349.856 354.26 350.288 353.58 350.8 352.972C351.328 352.348 351.96 351.852 352.696 351.484C353.432 351.116 354.288 350.932 355.264 350.932C356.4 350.932 357.312 351.196 358 351.724C358.704 352.236 359.056 352.972 359.056 353.932C359.056 354.46 358.92 354.996 358.648 355.54C358.392 356.084 357.96 356.596 357.352 357.076C356.76 357.556 355.96 357.964 354.952 358.3Z" fill="#8A929C"/>,
      bg: <path data-id="bg-13" d="M356.12 373.759L346.127 384.243L324.599 363.299L334.474 353.738L331.88 350.96L360.122 322.021L374.321 337.977L367.92 344.689L362.872 340.185L359.572 343.883L368.788 352.51L370.64 350.536L376.326 356.194L358.305 375.769L356.12 373.759Z" fill="#EFF0F2"/>
    },
  ];

  const onChangeApartamentsTabs = (tab) => {

    let tmpData, apartaments;

    switch (tab) {
      case "housing":
        tmpData = {...apartamentsData, activeTab: tab};
        apartaments = getApartaments(tmpData);
        setApartamentsData({...tmpData, apartaments});

        apartment_swiper.slideTo(0);
        break;
      case "view":
        if(!apartamentsData.housing){
          setToast({open: true, severity: "warning", text: "Сначала выберете корпус!"});
          return;
        };

        tmpData = {...apartamentsData, activeTab: tab};
        apartaments = getApartaments(tmpData);
        setApartamentsData({...tmpData, apartaments});

        apartment_swiper.slideTo(1);
        break;
      case "apartaments":
        if(!(apartamentsData.housing && apartamentsData.view)) {
          setToast({open: true, severity: "warning", text: "Сначала выберете корпус и вид!"});
          return;
        }

        tmpData = {...apartamentsData, activeTab: tab};
        apartaments = getApartaments(tmpData);
        setApartamentsData({...tmpData, apartaments});

        apartment_swiper.slideTo(2);
        break;
    }

  }

  const onChangeHouse = async (h) => {
    //при смене корпуса также обнуляется вид
    let tmpData = {...apartamentsData, housing: h, view: null, activeTab: "view"};
    let apartaments = getApartaments(tmpData);
    //при смене корпуса, если есть варианты выбора вида - обнуляем апартаменты
    tmpData = {...tmpData, apartaments: []};

    const availableViews = _.uniq(apartaments.map(a => a.views).flat());

    //устанавливаем доступные виды
    tmpData.availableSeaView =  !!availableViews.find(v => v == "sea");
    tmpData.availableMountainsView =  !!availableViews.find(v => v == "mountains");

    if(availableViews.length != 2){
      //если возможности выбора вида нет - устанавливаем доступный вид и вкладку апартаменты
      tmpData.view = availableViews[0];
      tmpData.activeTab = "apartaments";
      //если вариантов выбора вида нет - сохр апартаменты
      tmpData.apartaments = apartaments;
    }

    setApartamentsData(tmpData);
    await timeout(250);

    if(availableViews.length == 2){
      //если есть возможность выбора вида
      apartment_swiper.slideTo(1);
    }else{
      //если возможности выбора вида нет
      apartment_swiper.slideTo(2);
    }

  }

  const onChangeView = async (view) => {

    let tmpData = {...apartamentsData, view, viewText: (view == "sea"?"море":"горы"), activeTab: "apartaments"};
    let apartaments = getApartaments(tmpData);
    setApartamentsData({...tmpData, apartaments});

    await timeout(250);

    apartment_swiper.slideTo(2);
  };

  const onChangeMainSliderCategory = (cat) => {
    setMainSliderImages(mainSliderData[cat].images);
    setMainSliderActiveCat(cat);
  };

  const getActiveHouse = () => {
    let houseData;
    if(apartamentsData.housing){
      houseData = housingSvgData.find(g => g.id == apartamentsData.housing);
    }else{
      houseData = housingSvgData.find(g => g.id == apartamentsBlinkHouse);
    }

    if(!houseData) return null;

    //если выбран корпус - то подсвечиваем его, иначе вкл мигание корпуса
    return (
        <g data-id={houseData.id} className={clsx(apartamentsData.housing?"active":"blink")} onClick={() => onChangeHouse(houseData.id)}>
          {houseData.bg}
          {houseData.number}
          {houseData.border}
        </g>
    )

  }

  const onViewPhotosApartament = (house, number) => {
    setToast({open: true, severity: "warning", text: "Фотографии апартамента будут доступны в ближайшее время."});
  }

  const onViewPriceApartament = (house, number) => {
    setToast({open: true, severity: "warning", text: "Цены апартаментов будут доступны в ближайшее время."});
  }

  const renderDrawerNotSwSwitch = () => {
    switch (drawerNotSw.type) {
      case "loading":
        return <CircularProgress color="inherit" />;
      case "main_video":
        return (
            <>

              <div className="mainVideoWrapper">

                <IconButton size="small" onClick={() => {
                  pauseVideo();
                  setDrawerNotSw({...drawerNotSw, show: false});
                }} className={"bottomDrawerCloseBtnFS"}>
                  <CloseIcon fontSize="inherit"/>
                </IconButton>

                <video
                    ref={videoRef}
                    id="video"
                    src={video_about}
                    autoPlay
                    muted
                    playsinline
                    controls
                />

              </div>


            </>
        );
      default:
    }
  }

  const getMainSliderActiveCat = () => {
    const activeCat = mainSliderDataArr.find(t => t.id == mainSliderActiveCat);
    return (
        <li className="tab_active" style={{top: windowDimensions.width}} >
          <div className="content">
            <div className="title">
              <div className="order">
                {activeCat.index + 1}/11
              </div>
              <h2>{activeCat.title}</h2>
            </div>
          </div>
        </li>
    )
  }

  const getApartMapSize = () => {
    const width = (windowDimensions.width < 340?340:windowDimensions.width);
    return {width, height: width*1.236641}
  }

  const getNotActiveHousing = () => {
    if(apartamentsData.housing){
      return housingSvgData.filter(d => d.id != apartamentsData.housing);
    }
    return housingSvgData.filter(d => d.id != apartamentsBlinkHouse);
  }

  const getStepName = () => {
    switch (apartamentsData.activeTab || null) {
     case "housing":
       return "Выберете корпус";
      case "view":
        return "Выберете вид";
      case "apartaments":
        return "Выберете апартамент";
      default:
        return "";
    }
  }

  return (
    <main className="main_page container">

      <header id="main_header">
        <div className="container">
          <div className="wrap">
            {/*<button className="burger_btn">
              <Burger />
            </button>*/}
              <Logo className="logo"/>
            <a href="tel:+79384969700" className="phone">+7 938 496 97 00</a>
          </div>
        </div>
      </header>

      <div className="container mobile">

        {/* главный экран */}
        <section id="first_section" className="first_section">
          <img className="bg_img bg_img1" src={p1Child} alt="p1Child" />
          <img className="bg_img bg_img2" src={p1} alt="p1" />

          <h2 className="_title">
            THIS IS <br />GORIZONT
          </h2>

          <div className="window">
            <div className="content">
              <div className="section_title">
                <h3 className="main_title">
                  This is GORIZONT of your dreams
                </h3>
                <div className="subtitleWrapper">
                  <h1 className="subtitle">*<strong>Это горизонт</strong> {firstScreenHeaderTextArr[firstScreenHeaderTextIndex]}</h1>
                </div>
              </div>
              <p className="text">
                Окунитесь в неповторимую атмосферу элитного отдыха в самом сердце туристического центра Сочи!
              </p>

              <a href="#request" className="request_btn">
                Оставить заявку
              </a>

            </div>
          </div>
          <div className="img_dot"></div>
        </section>

        {/* главный слайдер */}
        <section id="discover" className="discover">
          <div className="section_title">
            <h3 className="main_title">DISCOVER A NEW GORIZONT</h3>
            <h2 className="subtitle">*ОТКРОЙТЕ НОВЫЙ ГОРИЗОНТ</h2>
          </div>
          <div className="tabs_container">

            <MainSliderWithMemo
                images={mainSliderImages || []}
                mainSwiper={mainSwiper}
                setMainSwiper={setMainSwiper}
                category={mainSliderActiveCat}
            />

            <ul className="tabs">

              {getMainSliderActiveCat()}

              {mainSliderDataArr.filter(t => t.id != mainSliderActiveCat).map(t => (
                  <li key={t.id} onClick={() => onChangeMainSliderCategory(t.id)}>
                    <div className="content">
                      <div className="title">
                        <div className="order">
                          {t.index + 1}/11
                        </div>
                        <h2>{t.title}</h2>
                      </div>
                    </div>
                  </li>
              ))
              }
            </ul>

          </div>
          <div className="img_dot"></div>
        </section>

        {/* карта локация */}
        <section id="location" className="location">
          <div className="section_title">
            <h3 className="main_title">WONDERFUL LOCATION</h3>
            <h2 className="subtitle">*Превосходная локация</h2>
          </div>
          <div className="wrap">

            <div id="map" className="map">
              <div className="flags">

                <span className="dot d1">
                  <span className="flag f3">
                    <p>ЖД Вокзал</p>
                    <small>
                      <SvgCar /> 15 мин.
                    </small>
                  </span>
                </span>

                <span className="dot d2">
                  <span className="flag f2">
                    <p>Аэропорт</p>
                    <small>
                      <SvgCar /> 10 мин.
                    </small>
                  </span>
                </span>

                <span className="dot d3">
                  <span className="flag f5">
                    <p>Олимпийские объекты</p>
                    <small>
                      <SvgCar /> 15 мин.
                    </small>
                  </span>
                </span>

                <span className="crc">
                  <span className="flag f0">
                    <p>GORIZONT</p>
                  </span>
                </span>

                <span className="arrow a1">
                  <SvgArrow />
                  <span className="flag f1">
                    <p>Центр Сочи</p>
                    <small>
                      <SvgCar /> 25 мин.
                    </small>
                  </span>
                </span>

                <span className="arrow a2">
                  <SvgArrow />
                  <span className="flag f4">
                    <p>Красная поляна</p>
                    <small>
                      <SvgCar /> 40 мин.
                    </small>
                  </span>
                </span>

              </div>
            </div>
          </div>
        </section>

        {/* выбор апартаментов  */}
        <section id="choose" className="choose">
          <div className="section_title">
            <h3 className="main_title">CHOOSE YOUR DREAM</h3>
            <h2 className="subtitle">*Купить апартаменты мечты</h2>
          </div>
          <div className="wrap">
            <div id="tab_slider" className="tab_slider">

              {!!windowDimensions?.width &&
                <Swiper
                  className="slider"
                  speed={1000}
                  simulateTouch={false}
                  touchEventsTarget="container"
                  noSwiping={true}
                  noSwipingSelector=".no-swipe"
                  spaceBetween={0}
                  slidesPerView={1}
                  centeredSlides={true}
                  //получаем экземпляр Swiper
                  onSwiper={(sw) => {
                    setApartmentSwiper(sw);
                  }}
                >

                  <SwiperSlide className="slide">
                    <div className="step step1 no-swipe">
                      <div className="content">
                        <div id="corps_body" className="houses_svg">
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              //width={windowDimensions.width}
                              //height={windowDimensions.width*1.236641}
                              {...getApartMapSize()}
                              viewBox="0 0 393 486"
                              fill="none"
                          >
                            <g data-id="bg">
                              <path data-id="plan" d="M393 0H0V486H393V0Z" fill="#F7F8FB"/>
                              <path data-id="sea" d="M194 486H0L0.00038445 215C0.00038445 215 0.499616 216 5.07806 223.21C6.85015 226.242 7.83726 230.189 8.76381 234.543L16.1013 257.103C22.0795 266.651 34.334 273.109 42.116 284.835C44.7813 288.85 46.5087 293.744 48.213 298.852L56.6667 318.288C63.2624 327.778 77.3068 333.364 84.8861 343.818C88.0606 348.197 89.1059 353.413 90.076 358.764L96.3502 376.832C103.214 385.941 119.675 391.815 127.215 401.482C135.331 411.886 135.493 428.766 144.411 439.777C152.083 449.248 169.202 454.095 177.481 463.987C186.376 474.614 184.39 474.918 194 486Z" fill="#DDECFF"/>
                              <path d="M271.657 97V87.2H276.039C277.141 87.2 277.999 87.4193 278.615 87.858C279.231 88.2873 279.539 88.908 279.539 89.72C279.539 90.5227 279.245 91.1433 278.657 91.582C278.069 92.0113 277.295 92.226 276.333 92.226L276.585 91.722C277.677 91.722 278.522 91.9413 279.119 92.38C279.717 92.8187 280.015 93.4533 280.015 94.284C280.015 95.1333 279.703 95.8007 279.077 96.286C278.452 96.762 277.528 97 276.305 97H271.657ZM273.449 95.6H276.249C276.884 95.6 277.365 95.4833 277.691 95.25C278.018 95.0073 278.181 94.6387 278.181 94.144C278.181 93.6493 278.018 93.29 277.691 93.066C277.365 92.8327 276.884 92.716 276.249 92.716H273.449V95.6ZM273.449 91.386H275.885C276.473 91.386 276.921 91.2693 277.229 91.036C277.537 90.7933 277.691 90.448 277.691 90C277.691 89.5333 277.537 89.1833 277.229 88.95C276.921 88.7167 276.473 88.6 275.885 88.6H273.449V91.386ZM282.103 97V87.2H283.895V94.158L289.159 87.2H290.853V97H289.061V90.056L283.797 97H282.103ZM300.015 96.16V88.74H296.179L296.109 90.476C296.081 91.1293 296.039 91.75 295.983 92.338C295.936 92.9167 295.857 93.444 295.745 93.92C295.642 94.396 295.497 94.7927 295.311 95.11C295.124 95.4273 294.895 95.6373 294.625 95.74L292.665 95.46C293.019 95.4787 293.309 95.3573 293.533 95.096C293.766 94.8347 293.948 94.4707 294.079 94.004C294.209 93.5373 294.307 92.9913 294.373 92.366C294.438 91.7313 294.485 91.0453 294.513 90.308L294.625 87.2H301.807V96.16H300.015ZM292.329 99.086L292.343 95.46H303.221V99.086H301.541V97H294.023V99.086H292.329ZM315.692 87.2H317.512V97H315.692V87.2ZM310.624 97H308.804V87.2H310.624V97ZM315.832 92.8H310.47V91.246H315.832V92.8ZM319.015 97L323.425 87.2H325.217L329.641 97H327.737L323.943 88.166H324.671L320.891 97H319.015ZM321.045 94.732L321.535 93.304H326.827L327.317 94.732H321.045ZM335.027 97V87.2H341.677L341.663 88.74H336.385L336.805 88.306L336.819 97H335.027ZM346.631 97.14C345.866 97.14 345.161 97.014 344.517 96.762C343.873 96.51 343.313 96.16 342.837 95.712C342.361 95.2547 341.992 94.7227 341.731 94.116C341.47 93.5 341.339 92.828 341.339 92.1C341.339 91.372 341.47 90.7047 341.731 90.098C341.992 89.482 342.361 88.95 342.837 88.502C343.313 88.0447 343.873 87.69 344.517 87.438C345.161 87.186 345.861 87.06 346.617 87.06C347.382 87.06 348.082 87.186 348.717 87.438C349.361 87.69 349.921 88.0447 350.397 88.502C350.873 88.95 351.242 89.482 351.503 90.098C351.764 90.7047 351.895 91.372 351.895 92.1C351.895 92.828 351.764 93.5 351.503 94.116C351.242 94.732 350.873 95.264 350.397 95.712C349.921 96.16 349.361 96.51 348.717 96.762C348.082 97.014 347.387 97.14 346.631 97.14ZM346.617 95.544C347.112 95.544 347.569 95.46 347.989 95.292C348.409 95.124 348.773 94.886 349.081 94.578C349.389 94.2607 349.627 93.8967 349.795 93.486C349.972 93.066 350.061 92.604 350.061 92.1C350.061 91.596 349.972 91.1387 349.795 90.728C349.627 90.308 349.389 89.944 349.081 89.636C348.773 89.3187 348.409 89.076 347.989 88.908C347.569 88.74 347.112 88.656 346.617 88.656C346.122 88.656 345.665 88.74 345.245 88.908C344.834 89.076 344.47 89.3187 344.153 89.636C343.845 89.944 343.602 90.308 343.425 90.728C343.257 91.1387 343.173 91.596 343.173 92.1C343.173 92.5947 343.257 93.052 343.425 93.472C343.602 93.892 343.845 94.2607 344.153 94.578C344.461 94.886 344.825 95.124 345.245 95.292C345.665 95.46 346.122 95.544 346.617 95.544ZM353.907 97V87.2H357.939C358.807 87.2 359.549 87.34 360.165 87.62C360.79 87.9 361.271 88.3013 361.607 88.824C361.943 89.3467 362.111 89.9673 362.111 90.686C362.111 91.4047 361.943 92.0253 361.607 92.548C361.271 93.0707 360.79 93.472 360.165 93.752C359.549 94.032 358.807 94.172 357.939 94.172H354.915L355.727 93.318V97H353.907ZM355.727 93.514L354.915 92.632H357.855C358.658 92.632 359.26 92.464 359.661 92.128C360.072 91.7827 360.277 91.302 360.277 90.686C360.277 90.0607 360.072 89.58 359.661 89.244C359.26 88.908 358.658 88.74 357.855 88.74H354.915L355.727 87.844V93.514ZM368.355 90.518C369.522 90.518 370.422 90.7793 371.057 91.302C371.692 91.8247 372.009 92.6087 372.009 93.654C372.009 94.7553 371.659 95.5907 370.959 96.16C370.268 96.72 369.302 97 368.061 97H363.847V87.2H365.639V90.518H368.355ZM367.977 95.6C368.677 95.6 369.218 95.4367 369.601 95.11C369.993 94.7833 370.189 94.3073 370.189 93.682C370.189 93.066 369.998 92.618 369.615 92.338C369.232 92.0487 368.686 91.904 367.977 91.904H365.639V95.6H367.977ZM373.423 97V87.2H375.215V97H373.423Z" fill="#AAAEB9"/>
                              <path d="M301.676 29.4204C301.705 29.8894 302.094 30.2548 302.564 30.2548H312.849C313.261 30.2548 313.62 29.9712 313.715 29.5697C313.773 29.3248 313.802 29.0791 313.802 28.8393C313.802 27.0929 312.381 25.672 310.635 25.672C310.249 25.672 309.873 25.741 309.519 25.875C308.841 25.1592 307.888 24.7376 306.88 24.7376C305.567 24.7376 304.354 25.462 303.716 26.5844C302.532 26.8993 301.668 27.9788 301.668 29.248C301.668 29.299 301.671 29.3491 301.675 29.3991L301.676 29.4204ZM304.37 28.273C304.719 28.2531 305.023 28.0308 305.149 27.7049C305.423 26.9945 306.119 26.5172 306.88 26.5172C307.546 26.5172 308.165 26.8781 308.494 27.4592C308.62 27.6818 308.836 27.8393 309.087 27.8915C309.337 27.9432 309.599 27.8852 309.803 27.7313C310.047 27.5481 310.334 27.4515 310.635 27.4515C311.274 27.4515 311.814 27.8858 311.974 28.4749H303.829C303.98 28.3583 304.166 28.2848 304.37 28.273Z" fill="#AAAEB9"/>
                              <path d="M334.25 26.5164C334.279 26.9856 334.668 27.3509 335.138 27.3509H347.717C348.13 27.3509 348.489 27.0673 348.583 26.6657C348.651 26.3812 348.685 26.0961 348.685 25.8182C348.685 23.7915 347.036 22.1428 345.009 22.1428C344.516 22.1428 344.037 22.2399 343.591 22.4279C342.794 21.5314 341.64 21 340.416 21C338.854 21 337.412 21.8783 336.679 23.232C335.274 23.566 334.241 24.8287 334.241 26.3183C334.241 26.3757 334.244 26.4321 334.248 26.4885L334.25 26.5164ZM337.335 24.9277C337.684 24.9076 337.988 24.6855 338.114 24.3596C338.479 23.4146 339.404 22.7797 340.416 22.7797C341.303 22.7797 342.126 23.2599 342.564 24.0328C342.69 24.2555 342.906 24.413 343.157 24.4651C343.407 24.5173 343.668 24.4587 343.873 24.3048C344.205 24.0547 344.598 23.9227 345.009 23.9227C345.971 23.9227 346.768 24.6424 346.889 25.5714H336.238C336.472 25.2055 336.872 24.9544 337.335 24.9277Z" fill="#AAAEB9"/>
                              <path d="M361.991 57.377C359.318 56.9867 356.566 56.6803 353.774 56.4555L359.964 45.8095V48.4077C359.964 48.9484 360.402 49.3866 360.943 49.3866C361.483 49.3866 361.922 48.9484 361.922 48.4077V42.1787C361.922 41.8432 361.75 41.5311 361.466 41.3517C361.182 41.1721 360.827 41.1506 360.524 41.2942L356.285 43.3021L357.406 41.0066C358.924 39.9078 360.346 38.7542 361.616 37.55C362.008 37.1781 362.025 36.5585 361.653 36.1663C361.281 35.774 360.661 35.7575 360.269 36.1296C357.609 38.6526 354.199 40.9683 350.62 43.0106C347.165 41.5839 345.283 39.9539 343.615 38.5089C343.055 38.024 342.527 37.566 341.963 37.132C341.634 36.8792 341.182 36.8607 340.834 37.086C338.463 38.6202 333.637 39.6987 332.106 40.0133C327.971 36.1259 324.826 32.6738 322.591 30.2193C321.926 29.4877 320.829 29.0878 319.579 29.1244C318.31 29.1609 317.194 29.624 316.595 30.3635C313.631 34.0242 308.435 38.5881 303.535 42.559C302.128 42.2823 297.427 41.1947 293.144 38.3393C292.71 38.0498 292.125 38.1519 291.814 38.5719C288.905 42.5074 281.927 47.9356 281.857 47.99C281.43 48.3213 281.352 48.9361 281.683 49.3633C281.876 49.6123 282.165 49.7425 282.457 49.7425C282.667 49.7425 282.878 49.6756 283.056 49.5373C283.226 49.406 285.6 47.5588 288.171 45.2235L288.477 46.0708C288.583 46.3627 288.82 46.5871 289.118 46.6759C289.21 46.7033 289.304 46.7168 289.398 46.7168C289.607 46.7168 289.814 46.6497 289.985 46.5211L292.422 44.6931L294.605 45.4208C295.06 45.5726 295.558 45.3723 295.781 44.948L297.018 42.5973C298.79 43.3357 300.392 43.8205 301.581 44.1243C296.728 47.9701 292.536 50.9933 291.651 51.6271C288.256 52.2612 284.922 53.0774 281.688 54.084C281.172 54.2447 280.884 54.7932 281.044 55.3095C281.205 55.8256 281.753 56.114 282.27 55.9532C291.442 53.0987 301.668 51.7367 311.843 52.0152C320.438 52.2504 328.896 53.6626 336.596 56.1227C334.225 56.2206 331.876 56.375 329.574 56.5943C317.103 57.7823 306.156 60.7496 297.887 65.1777C292.546 65.1482 287.199 65.4203 281.874 65.995C281.337 66.053 280.948 66.5357 281.006 67.0731C281.064 67.6108 281.548 67.9991 282.084 67.9413C294.107 66.644 306.244 66.9094 318.158 68.7297C329.886 70.5215 340.817 73.7277 350.65 78.2592C350.782 78.3204 350.922 78.3493 351.059 78.3493C351.429 78.3493 351.783 78.138 351.948 77.7799C352.175 77.2889 351.96 76.7075 351.469 76.4813C341.47 71.873 330.362 68.614 318.454 66.7944C313.049 65.9686 307.599 65.4609 302.134 65.2669C320.142 57.1343 345.059 56.8826 361.708 59.3141C362.243 59.392 362.74 59.0218 362.818 58.487C362.896 57.9522 362.526 57.4552 361.991 57.377ZM294.436 43.3008L292.555 42.6738C292.25 42.5722 291.915 42.6267 291.658 42.8194L289.869 44.1615L289.727 43.7682C290.856 42.6774 291.945 41.5403 292.825 40.4597C293.63 40.9573 294.439 41.3978 295.232 41.7881L294.436 43.3008ZM353.35 44.8504L349.131 50.0074L347.885 49.328C347.595 49.1698 347.244 49.1688 346.953 49.3252L337.577 54.3659C336.118 53.8886 334.637 53.4506 333.137 53.0519C337.79 51.3884 346.616 47.9238 354.162 43.1876L353.35 44.8504ZM327.577 51.7688L326.12 45.8597C326.057 45.6025 325.892 45.382 325.663 45.2486L323.825 44.1765L322.261 40.0883L327.513 44.4852L331.915 49.4156C332.162 49.6925 332.545 49.8054 332.903 49.708L334.124 49.375L334.688 50.379C332.144 51.3464 330.281 51.97 329.604 52.1911C328.932 52.0423 328.256 51.9022 327.577 51.7688ZM341.284 39.0941C341.629 39.3776 341.974 39.6771 342.333 39.9881C342.831 40.4196 343.348 40.8669 343.914 41.3207L341.782 42.7854L340.561 41.0758C340.337 40.7622 339.95 40.6092 339.572 40.685L338.081 40.9831L338.085 40.4479C339.226 40.0601 340.351 39.6067 341.284 39.0941ZM336.123 41.0538L336.115 42.1725C336.113 42.4669 336.244 42.7464 336.471 42.9339C336.698 43.1213 336.998 43.1964 337.286 43.1387L339.335 42.729L340.747 44.7056C340.938 44.9727 341.239 45.1156 341.544 45.1156C341.735 45.1156 341.928 45.0597 342.098 44.9435L345.582 42.5505C346.408 43.1052 347.351 43.6586 348.469 44.1953C345.984 45.5196 343.475 46.7099 341.127 47.7432C338.454 45.6643 336.035 43.6053 333.86 41.6341C334.515 41.4816 335.294 41.2871 336.123 41.0538ZM339.078 48.6234C338.191 48.9958 337.338 49.3432 336.531 49.663L335.456 47.75C335.236 47.359 334.78 47.1669 334.345 47.2853L332.972 47.6597L329.137 43.3644L328.735 39.4924C331.614 42.312 335.05 45.434 339.078 48.6234ZM318.116 31.5951C318.31 31.3555 318.894 31.1019 319.635 31.0807C320.29 31.0603 320.87 31.2364 321.143 31.5365C322.569 33.1018 324.36 35.0687 326.539 37.2946L326.973 41.4802L321.171 36.623C320.783 36.2974 320.209 36.3227 319.851 36.6813L317.646 38.8861L317.341 38.2142C317.222 37.9528 316.994 37.7568 316.718 37.678C316.442 37.5991 316.145 37.6454 315.907 37.8047L312.121 40.3285L312.92 37.0456C314.938 35.149 316.745 33.289 318.116 31.5951ZM307.744 50.0248C306.264 50.0479 304.785 50.1044 303.309 50.1946L311.173 43.3136L316.035 40.0724L316.255 40.557L314.599 43.8696H313.068C312.768 43.8696 312.485 44.007 312.299 44.2427L307.744 50.0248ZM310.332 39.4007L309.699 42.0022L300.045 50.4493C298.667 50.5803 297.295 50.7413 295.93 50.9312C299.471 48.3074 305.241 43.8992 310.332 39.4007ZM310.244 50.015L313.543 45.8272H315.204C315.575 45.8272 315.914 45.6177 316.079 45.2859L318.144 41.1568L319.901 39.3995L322.12 45.198C322.2 45.4064 322.348 45.5812 322.541 45.6937L324.319 46.7307L325.466 51.3802C320.481 50.5219 315.369 50.0659 310.244 50.015ZM342.101 56.0025C341.437 55.7384 340.766 55.4841 340.091 55.2374L347.414 51.3007L348.906 52.1147C349.319 52.34 349.834 52.2395 350.132 51.8752L354.798 46.1726L358.511 44.4137L351.601 56.2983C348.457 56.0951 345.274 55.996 342.101 56.0025Z" fill="#AAAEB9"/>
                              <path d="M38.4502 454V444.2H39.9342L44.2322 451.354H43.4342L47.6622 444.2H49.1462L49.1742 454H47.4382L47.4242 446.902H47.7882L44.2042 452.88H43.3922L39.7522 446.902H40.1722V454H38.4502ZM56.4667 454.14C55.7013 454.14 54.9967 454.014 54.3527 453.762C53.7087 453.51 53.1487 453.16 52.6727 452.712C52.1967 452.255 51.828 451.723 51.5667 451.116C51.3053 450.5 51.1747 449.828 51.1747 449.1C51.1747 448.372 51.3053 447.705 51.5667 447.098C51.828 446.482 52.1967 445.95 52.6727 445.502C53.1487 445.045 53.7087 444.69 54.3527 444.438C54.9967 444.186 55.6967 444.06 56.4527 444.06C57.218 444.06 57.918 444.186 58.5527 444.438C59.1967 444.69 59.7567 445.045 60.2327 445.502C60.7087 445.95 61.0773 446.482 61.3387 447.098C61.6 447.705 61.7307 448.372 61.7307 449.1C61.7307 449.828 61.6 450.5 61.3387 451.116C61.0773 451.732 60.7087 452.264 60.2327 452.712C59.7567 453.16 59.1967 453.51 58.5527 453.762C57.918 454.014 57.2227 454.14 56.4667 454.14ZM56.4527 452.544C56.9473 452.544 57.4047 452.46 57.8247 452.292C58.2447 452.124 58.6087 451.886 58.9167 451.578C59.2247 451.261 59.4627 450.897 59.6307 450.486C59.808 450.066 59.8967 449.604 59.8967 449.1C59.8967 448.596 59.808 448.139 59.6307 447.728C59.4627 447.308 59.2247 446.944 58.9167 446.636C58.6087 446.319 58.2447 446.076 57.8247 445.908C57.4047 445.74 56.9473 445.656 56.4527 445.656C55.958 445.656 55.5007 445.74 55.0807 445.908C54.67 446.076 54.306 446.319 53.9887 446.636C53.6807 446.944 53.438 447.308 53.2607 447.728C53.0927 448.139 53.0087 448.596 53.0087 449.1C53.0087 449.595 53.0927 450.052 53.2607 450.472C53.438 450.892 53.6807 451.261 53.9887 451.578C54.2967 451.886 54.6607 452.124 55.0807 452.292C55.5007 452.46 55.958 452.544 56.4527 452.544ZM63.7428 454V444.2H67.7748C68.6428 444.2 69.3848 444.34 70.0008 444.62C70.6262 444.9 71.1068 445.301 71.4428 445.824C71.7788 446.347 71.9468 446.967 71.9468 447.686C71.9468 448.405 71.7788 449.025 71.4428 449.548C71.1068 450.071 70.6262 450.472 70.0008 450.752C69.3848 451.032 68.6428 451.172 67.7748 451.172H64.7508L65.5628 450.318V454H63.7428ZM65.5628 450.514L64.7508 449.632H67.6908C68.4935 449.632 69.0955 449.464 69.4968 449.128C69.9075 448.783 70.1128 448.302 70.1128 447.686C70.1128 447.061 69.9075 446.58 69.4968 446.244C69.0955 445.908 68.4935 445.74 67.6908 445.74H64.7508L65.5628 444.844V450.514ZM75.3486 448.274H80.2206V449.772H75.3486V448.274ZM75.4886 452.474H81.0186V454H73.6686V444.2H80.8226V445.726H75.4886V452.474Z" fill="#8DA5C6"/>
                              <path d="M43.6441 386.63H51.0746C51.6837 386.63 52.1777 386.136 52.1777 385.527C52.1777 384.917 51.6837 384.423 51.0746 384.423H43.6441C43.0347 384.423 42.541 384.917 42.541 385.527C42.541 386.136 43.0347 386.63 43.6441 386.63Z" fill="#8DA5C6"/>
                              <path d="M67.958 385.527C67.958 386.136 68.4517 386.63 69.0611 386.63H76.491C77.1 386.63 77.5941 386.136 77.5941 385.527C77.5941 384.917 77.1 384.423 76.491 384.423H69.0611C68.4515 384.423 67.958 384.917 67.958 385.527Z" fill="#8DA5C6"/>
                              <path d="M65.7451 391.204C65.3142 391.635 65.3142 392.333 65.7451 392.764L68.28 395.299C68.4954 395.514 68.7777 395.622 69.0599 395.622C69.3421 395.622 69.6247 395.514 69.8401 395.299C70.2706 394.868 70.2706 394.17 69.8401 393.739L67.3052 391.204C66.8743 390.773 66.1759 390.773 65.7451 391.204Z" fill="#8DA5C6"/>
                              <path d="M58.9648 394.897V401.95C58.9648 402.559 59.4585 403.053 60.0679 403.053C60.6769 403.053 61.171 402.559 61.171 401.95V394.897C61.171 394.287 60.6769 393.793 60.0679 393.793C59.4585 393.793 58.9648 394.287 58.9648 394.897Z" fill="#8DA5C6"/>
                              <path d="M52.8304 391.204L50.2958 393.739C49.865 394.17 49.865 394.868 50.2958 395.299C50.5112 395.514 50.7935 395.622 51.0757 395.622C51.3582 395.622 51.6405 395.514 51.8559 395.299L54.3905 392.764C54.8214 392.333 54.8214 391.635 54.3905 391.204C53.9598 390.773 53.2613 390.773 52.8304 391.204Z" fill="#8DA5C6"/>
                              <path d="M60.0678 392.675C64.0093 392.675 67.2161 389.468 67.2161 385.526C67.2161 381.585 64.0092 378.378 60.0678 378.378C56.1259 378.378 52.9189 381.585 52.9189 385.526C52.9189 389.468 56.1259 392.675 60.0678 392.675ZM60.0678 380.584C62.7929 380.584 65.0099 382.801 65.0099 385.526C65.0099 388.251 62.7929 390.468 60.0678 390.468C57.3423 390.468 55.1251 388.251 55.1251 385.526C55.1251 382.801 57.3423 380.584 60.0678 380.584Z" fill="#8DA5C6"/>
                              <path d="M52.8307 379.849C53.0458 380.065 53.3284 380.172 53.6106 380.172C53.8929 380.172 54.1751 380.065 54.3905 379.849C54.8214 379.418 54.8214 378.72 54.3905 378.289L51.8559 375.755C51.4251 375.324 50.7266 375.324 50.2958 375.755C49.865 376.185 49.865 376.884 50.2958 377.315L52.8307 379.849Z" fill="#8DA5C6"/>
                              <path d="M60.0679 377.26C60.6769 377.26 61.171 376.766 61.171 376.157V369.103C61.171 368.494 60.6769 368 60.0679 368C59.4585 368 58.9648 368.494 58.9648 369.103V376.157C58.9648 376.766 59.4585 377.26 60.0679 377.26Z" fill="#8DA5C6"/>
                              <path d="M66.5249 380.172C66.8071 380.172 67.0897 380.064 67.3049 379.849L69.8398 377.315C70.2706 376.884 70.2706 376.185 69.8401 375.755C69.4093 375.324 68.7108 375.324 68.28 375.754L65.7451 378.289C65.3142 378.72 65.3142 379.418 65.7451 379.849C65.9605 380.065 66.2426 380.172 66.5249 380.172Z" fill="#8DA5C6"/>
                              <path d="M87.8219 408.507C86.2131 408.507 85.4668 407.917 84.5219 407.169C83.4472 406.319 82.2289 405.356 79.8534 405.356C77.4776 405.356 76.2593 406.319 75.1846 407.169C74.2397 407.917 73.4934 408.507 71.8847 408.507C70.2766 408.507 69.5302 407.917 68.5852 407.169C67.5108 406.319 66.2925 405.356 63.9173 405.356C61.5419 405.356 60.3236 406.319 59.2492 407.169C58.3043 407.917 57.5579 408.507 55.9496 408.507C54.3414 408.507 53.5951 407.917 52.6504 407.169C51.5756 406.319 50.3577 405.356 47.9822 405.356C45.6068 405.356 44.3888 406.319 43.3143 407.169C42.3695 407.917 41.6234 408.507 40.0151 408.507C38.4066 408.507 37.6606 407.917 36.7156 407.169C35.6408 406.319 34.4229 405.356 32.0474 405.356C31.438 405.356 30.9443 405.849 30.9443 406.459C30.9443 407.068 31.438 407.562 32.0474 407.562C33.6556 407.562 34.4019 408.152 35.3466 408.9C36.4214 409.75 37.6397 410.714 40.0151 410.714C42.3903 410.714 43.6086 409.75 44.683 408.9C45.6279 408.152 46.3739 407.562 47.9822 407.562C49.5905 407.562 50.3367 408.152 51.2813 408.9C52.356 409.75 53.574 410.714 55.9495 410.714C58.3249 410.714 59.5429 409.75 60.6176 408.9C61.5625 408.152 62.3085 407.562 63.9172 407.562C65.5253 407.562 66.2714 408.152 67.2164 408.9C68.2911 409.75 69.5091 410.714 71.8846 410.714C74.2604 410.714 75.4783 409.75 76.5531 408.9C77.498 408.152 78.2444 407.562 79.8531 407.562C81.4616 407.562 82.2079 408.152 83.1528 408.9C84.2275 409.75 85.4458 410.714 87.8216 410.714C88.4307 410.714 88.9247 410.219 88.9247 409.61C88.925 409.001 88.431 408.507 87.8219 408.507Z" fill="#8DA5C6"/>
                              <path d="M87.8219 428.707C86.2131 428.707 85.4668 428.116 84.5219 427.369C83.4472 426.519 82.2289 425.555 79.8534 425.555C77.4776 425.555 76.2593 426.519 75.1846 427.369C74.2397 428.116 73.4934 428.707 71.8847 428.707C70.2766 428.707 69.5302 428.116 68.5852 427.369C67.5108 426.519 66.2925 425.555 63.9173 425.555C61.5419 425.555 60.3236 426.519 59.2492 427.369C58.3043 428.116 57.5579 428.707 55.9496 428.707C54.3414 428.707 53.5951 428.116 52.6504 427.369C51.5756 426.519 50.3577 425.555 47.9822 425.555C45.6068 425.555 44.3888 426.519 43.3143 427.369C42.3695 428.116 41.6234 428.707 40.0151 428.707C38.4066 428.707 37.6606 428.116 36.7156 427.369C35.6408 426.519 34.4229 425.555 32.0474 425.555C31.438 425.555 30.9443 426.049 30.9443 426.658C30.9443 427.267 31.438 427.761 32.0474 427.761C33.6556 427.761 34.4019 428.352 35.3466 429.099C36.4214 429.949 37.6397 430.913 40.0151 430.913C42.3903 430.913 43.6086 429.949 44.683 429.099C45.6279 428.352 46.3739 427.761 47.9822 427.761C49.5905 427.761 50.3367 428.352 51.2813 429.099C52.356 429.949 53.574 430.913 55.9495 430.913C58.3249 430.913 59.5429 429.949 60.6176 429.099C61.5625 428.352 62.3085 427.761 63.9172 427.761C65.5253 427.761 66.2714 428.352 67.2164 429.099C68.2911 429.949 69.5091 430.913 71.8846 430.913C74.2604 430.913 75.4783 429.95 76.5531 429.099C77.498 428.352 78.2444 427.761 79.8531 427.761C81.4616 427.761 82.2079 428.352 83.1528 429.099C84.2275 429.949 85.4458 430.913 87.8216 430.913C88.4307 430.913 88.9247 430.419 88.9247 429.81C88.925 429.201 88.431 428.707 87.8219 428.707Z" fill="#8DA5C6"/>
                              <path d="M71.8776 415.283C70.2688 415.283 69.5225 414.693 68.5776 413.945C67.5029 413.095 66.2846 412.132 63.9091 412.132C61.5333 412.132 60.315 413.095 59.2403 413.945C58.2954 414.693 57.5491 415.283 55.9404 415.283C54.3323 415.283 53.5859 414.693 52.6409 413.945C51.5665 413.095 50.3482 412.132 47.973 412.132C45.5976 412.132 44.3793 413.095 43.3049 413.945C42.36 414.693 41.6136 415.283 40.0053 415.283C38.3971 415.283 37.6508 414.693 36.7061 413.945C35.6313 413.095 34.4134 412.132 32.0379 412.132C29.6625 412.132 28.4445 413.095 27.37 413.945C26.4252 414.693 25.6791 415.283 24.0708 415.283C22.4623 415.283 21.7163 414.693 20.7713 413.945C19.6965 413.095 18.4786 412.132 16.1031 412.132C15.4937 412.132 15 412.625 15 413.235C15 413.844 15.4937 414.338 16.1031 414.338C17.7113 414.338 18.4576 414.928 19.4023 415.676C20.4771 416.526 21.6954 417.49 24.0708 417.49C26.446 417.49 27.6643 416.526 28.7387 415.676C29.6836 414.928 30.4296 414.338 32.0379 414.338C33.6462 414.338 34.3924 414.928 35.337 415.676C36.4117 416.526 37.6297 417.49 40.0052 417.49C42.3806 417.49 43.5986 416.526 44.6733 415.676C45.6182 414.928 46.3642 414.338 47.9729 414.338C49.581 414.338 50.3271 414.928 51.2721 415.676C52.3468 416.526 53.5648 417.49 55.9403 417.49C58.3161 417.49 59.534 416.526 60.6088 415.676C61.5537 414.928 62.3001 414.338 63.9088 414.338C65.5173 414.338 66.2636 414.928 67.2085 415.676C68.2832 416.526 69.5015 417.49 71.8773 417.49C72.4864 417.49 72.9804 416.996 72.9804 416.386C72.9807 415.777 72.4867 415.283 71.8776 415.283Z" fill="#8DA5C6"/>
                              <path d="M103.767 422.06C102.158 422.06 101.412 421.469 100.467 420.722C99.3926 419.872 98.1742 418.908 95.7987 418.908C93.4229 418.908 92.2046 419.872 91.1299 420.722C90.185 421.469 89.4388 422.06 87.8301 422.06C86.222 422.06 85.4755 421.469 84.5305 420.722C83.4561 419.872 82.2378 418.908 79.8626 418.908C77.4872 418.908 76.2689 419.872 75.1945 420.722C74.2496 421.469 73.5032 422.06 71.8949 422.06C70.2868 422.06 69.5404 421.469 68.5957 420.722C67.521 419.872 66.303 418.908 63.9275 418.908C61.5521 418.908 60.3341 419.872 59.2597 420.722C58.3148 421.469 57.5688 422.06 55.9604 422.06C54.3519 422.06 53.6059 421.469 52.6609 420.722C51.5861 419.872 50.3682 418.908 47.9927 418.908C47.3833 418.908 46.8896 419.402 46.8896 420.011C46.8896 420.62 47.3833 421.114 47.9927 421.114C49.6009 421.114 50.3472 421.705 51.2919 422.452C52.3667 423.302 53.585 424.266 55.9604 424.266C58.3356 424.266 59.5539 423.302 60.6283 422.452C61.5732 421.705 62.3192 421.114 63.9275 421.114C65.5358 421.114 66.2821 421.705 67.2267 422.452C68.3014 423.302 69.5193 424.266 71.8948 424.266C74.2702 424.266 75.4882 423.302 76.5629 422.452C77.5078 421.705 78.2538 421.114 79.8625 421.114C81.4706 421.114 82.2167 421.705 83.1617 422.452C84.2364 423.302 85.4544 424.266 87.8299 424.266C90.2057 424.266 91.4236 423.302 92.4984 422.452C93.4433 421.705 94.1898 421.114 95.7985 421.114C97.407 421.114 98.1532 421.705 99.0981 422.452C100.173 423.302 101.391 424.266 103.767 424.266C104.376 424.266 104.87 423.772 104.87 423.163C104.87 422.553 104.376 422.06 103.767 422.06Z" fill="#8DA5C6"/>
                            </g>

                            {(getNotActiveHousing()).map(d => {
                              return (
                                  <g key={d.id} onClick={() => onChangeHouse(d.id)} data-id={d.id} className="blink-1">
                                    {d.bg}
                                    {d.number}
                                    {d.border}
                                  </g>
                              )
                            })}

                            {getActiveHouse()}

                            <defs>
                              <clipPath >
                                <rect {...getApartMapSize()} fill="white"/>
                              </clipPath>
                            </defs>

                          </svg>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide className="slide">

                    <div className="step step2 no-swipe">
                      <div className="content">

                        <input type="radio" id="select_sea" disabled={!apartamentsData.availableSeaView} checked={apartamentsData.view && apartamentsData.view == "sea" || false} onChange={() => {}} onClick={() => onChangeView("sea")}/>
                        <label htmlFor="select_sea" className={clsx((!apartamentsData.availableSeaView?"disabled":null))}>
                          <img src={choose1} alt="вид на море" />
                          <div className="wrap_w">
                            <div className="window">
                              <h3>вид на море</h3>
                            </div>
                          </div>
                        </label>

                        <input type="radio" disabled={!apartamentsData.availableMountainsView} id="select_mountains" checked={apartamentsData.view && apartamentsData.view == "mountains" || false} onChange={() => {}} onClick={() => onChangeView("mountains")}/>
                        <label htmlFor="select_mountains" className={clsx((!apartamentsData.availableMountainsView?"disabled":null))}>
                          <img src={choose2} alt="вид на горы" />
                          <div className="wrap_w">
                            <div className="window">
                              <h3>вид на горы</h3>
                            </div>
                          </div>
                        </label>

                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide className="slide">
                    <div className="step step3 no-swipe">
                      <div className="content">

                        <ApartamentsDataSliderWithMemo
                            apartamentsData={apartamentsData}
                            onViewPhotosApartament={onViewPhotosApartament}
                            onViewPriceApartament={onViewPriceApartament}
                        />

                      </div>
                    </div>
                  </SwiperSlide>

                </Swiper>
              }
              <div className="steps">

                <h3 className="title">
                  <CaretUpFill />
                  {getStepName()}
                </h3>

                <div className="tabs">

                  <button className={clsx("btn", (apartamentsData.activeTab == "housing"?"active":null))} onClick={() => onChangeApartamentsTabs("housing")}>
                    {apartamentsData.housing?"Корпус":"Корпусы"}
                    <span>{apartamentsData.housing ? `№${apartamentsData.housing}` : "Шаг 1"}</span>
                  </button>

                  <button className={clsx("btn", (apartamentsData.activeTab == "view"?"active":null))} onClick={() => onChangeApartamentsTabs("view")}>
                    {apartamentsData.view?"Вид":"Виды"}
                    <span>{apartamentsData.view ? apartamentsData.view == "sea"?"море":"горы" : "Шаг 2"}</span>
                  </button>

                  <button className={clsx("btn", (apartamentsData.activeTab == "apartaments"?"active":null))} onClick={() => onChangeApartamentsTabs("apartaments")}>
                    Планировки
                    <span>{apartamentsData.apartaments?.length ? ("всего "+apartamentsData.apartaments.length)+" план." : "Просмотр"}</span>
                  </button>

                </div>
              </div>

            </div>
          </div>
        </section>

        <section id="overview" className="overview">

          {!showVideo &&
            <div className="video">
              <img src={overview} alt="overview" />
            </div>
          }

          <div className="window">

            {showVideo &&
              <video
                  style={{height: (windowDimensions.width-33)}}
                  className="videoInWindow"
                  ref={videoRef}
                  id="video"
                  src={video_about}
                  muted
                  controls
                  autoPlay
                  loop
                  playsInline
              />
            }

            {!showVideo &&
              <button id="video_btn" className="video_btn" onClick={() => setShowVideo(true)}>
                <PlayCircleFill className="play_icon" />
              </button>
            }

            <div className="videoContent">
              <div className="content">

                <div className="section_title">
                  <span className="main_title">Apart Hotel overview</span>
                  <h2 className="subtitle">*Видео-обзор апарт-отеля</h2>
                </div>
                <p className="text">
                  Окунитесь в неповторимую атмосферу элитного отдыха в самом сердце туристического центра Сочи, где каждый день начинается с улыбки и изумительных видов на море. Отдыхайте и наслаждайтесь беззаботной жизнью в одном из лучших премиальных комплексов Сочи!
                </p>
              </div>
            </div>
          </div>

          <div className="img_dot"></div>
        </section>

        <section className="info">

          <div className="section_title">
            <h3 className="main_title">About the legend</h3>
            <h2 className="subtitle">*О легендартном проекте</h2>
          </div>
          <div className="wrap">
            <img className="img" src={info} alt="info" />

            <div className="content">
              <div className="text">
                <p><strong>GORIZONT</strong> - премиальный апартаментный комплекс (апарт-отель), расположенный в 40 метрах от моря в самом сердце Адлерского микрорайона.</p>
                <p>Центр Адлера - <strong>одна из самых лучших локаций для комфортного отдыха и постоянного проживания или сдачи в аренду</strong>, здесь самая богатая инфраструктура Сочи: лучшие рестораны и кафе, огромное разнообразие магазинов и торговых центров, школы и д/с, социальная инфраструктура и многе другое.</p>
                <p><strong>GORIZONT (ГОРИЗОНТ)</strong> находится на финальном этапе строительства, <strong>срок сдачи 2кв. 2025г.</strong> Комплекс состоит из 13 корпусов, 14 этажей, 2 подземных этажа, коммерция, парковка, статус апартаменты. В настоящий момент доступна покупка только за наличный расчет.</p>
                <p>Купить квартиру или апартаменты в Сочи - это большая удача, а покупка апартаментов в отеле GORIZONT - это мечта, которая может стать реальной!</p>
              </div>
              <button className="btn">Отправить заявку</button>
            </div>
          </div>
        </section>

        <section className="investment">
          <div className="section_title">
            <h3 className="main_title">INVESTMENT IN THE FUTURE</h3>
            <h2 className="subtitle">*ИНВЕСТИЦИИ В БУДУЩЕЕ</h2>
          </div>

          <div className="tab_slider">
            <div className="tabs">
              <button className="btn active" onClick={() => {invSliding(0)}}>Аренда</button>
              <button className="btn" onClick={() => {invSliding(1)}}>Перепродажа</button>
            </div>

            <Swiper
              speed={1000}
              spaceBetween={0}
              slidesPerView={1}
              centeredSlides={true}
              onSwiper={(s) => {
                setInvestment_slider(s);
              }}
              onSlideChange={(s) => {
                invSliding(s?.activeIndex);
              }}
            >
              <SwiperSlide>
                <div className="slide">
                  <h4 className="text_title">Пассивный доход с посуточной аренды</h4>
                  <p>Комплекс расположен в самом туристическом районе Сочи –{" "}<strong>центр Адлера, это идеальная локация для сдачи недвижимости в аренду.</strong> В центре Адлера постоянный высокий спрос на аренду в летний и зимний период.</p>
                  <p>Благодаря выгодной локации, будет обеспечена высокая доходность со сдачи апартаментов в аренду{" "}<strong>круглый год.</strong> Купив апартаменты с доверительным управлением в Сочи, в апарт-отеле GORIZONT - <strong>вы приобретаете готовый и отлаженный бизнес</strong> у моря, который будет стабильно приносить вам дивиденды.</p>
                  <p>Вы можете запросить отчет у управляющей компании по аналогичным объектам, находящимся в доверительном управлении.</p>
                  <a href="#request" className="report_btn"><Report />Запросить отчет</a>

                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="slide">
                  <h4 className="text_title">Покупка апартаментов с целью перепродажи</h4>
                  <p>GORIZONT - <strong>обладает высокой инвестиционной привлекательностью</strong>. Ожидается рост стоимости апартаментов как на этапе строительства, так и в течение нескольких лет после сдачи объекта.</p>
                  <img src={in2} alt="in2" />
                  <p>Рост цен обусловлен премиальным уровнем объекта, его архитектурой и <strong>самым важным - его уникальной локацией</strong>. На сегодняшний день вся береговая линия в Сочи застроена, при этом спрос на недвижимость, расположенную в шаговой доступности от моря неуклонно растет...</p>
                </div>
              </SwiperSlide>

            </Swiper>
          </div>
        </section>

        <section id="request" className="request">

          <Formik
            initialValues={{
              name: "",
              phone: "",
              message: ""
            }}
            onSubmit={async (values, {setSubmitting, resetForm}) => {

              let result;
              try{
                result = await MainService.sendRequest(values);
              }catch (e) {
                setToast({open: true, severity: "error", text: "Возникла ошибка при отправке заявки: "+e.message});
                return;
              }


              if(result?.status){
                setToast({open: true, severity: "success", text: "Заявка успешно отправлена!"});
                setSubmitting(true);
                resetForm();
                return;
              }

              setToast({open: true, severity: "error", text: "Возникла ошибка при отправке заявки"+(result?.error?": "+result.error:".")});
              setSubmitting(true);
            }}
          >
            <Form id="request_form" name="request" className="form">
              <div className="title">
                <h2>Отправьте заявку</h2>
                <h3>Чтобы купить апартаменты в GORIZONT (ГОРИЗОНТ), для получения консультации или другой информации по апарт-отелю отправьте заявку.</h3>
              </div>
              <div className="body">
                <Field
                  type="text"
                  minLength={3}
                  required
                  placeholder="Ваше имя"
                  name="name"
                  autoComplete="true"
                />
                <Field
                  type="tel"
                  minLength={10}
                  required
                  placeholder="Контактный телефон"
                  name="phone"
                  autoComplete="true"
                />
                <Field
                  as="textarea"
                  id="form_message"
                  name="message"
                  cols="8"
                  rows="3"
                  placeholder="Ваше сообщение"
                  required
                />
                <button type="submit" className="send_btn">Отправить заявку</button>
              </div>
            </Form>
          </Formik>
        </section>

        <section id="contacts" className="contacts">
          <div className="map">
            <div className="flags">
              <span className="crc">
                <span className="flag f0">
                  <p>GORIZONT</p>
                </span>
              </span>
            </div>
          </div>

          <div className="card">
            <div className="section_title">
              <h3 className="main_title">Follow your dreams</h3>
              <h2 className="subtitle">
                *Сделайте первый шаг на встречу вашей мечте !
              </h2>
            </div>
            <hr />
            <div className="contact_info">
              <span className="t1">АДРЕС:</span>
              <span className="t2">Сочи, ул. Просвещения, д. 32</span>
            </div>
            <div className="contact_info">
              <span className="t1">Контактный телефон:</span>
              <a href="tel:+79384969700" className="t2">+7 938 496 97 00</a>
            </div>
            <div className="social_links">
              <a href="https://wa.me/79225009990" target="_blank">
                <SvgWhatsapp /> WhatsApp
              </a>
              <a href="https://t.me/GeorgeAndryukov" target="_blank">
                <SvgTelegram /> Telegram
              </a>
            </div>
          </div>
        </section>
      </div>

      <CustomSnackbar toast={toast} setToast={setToast}/>

      <Drawer
          anchor="bottom"
          open={drawerNotSw.show}
          transitionDuration={0}
          onClose={(event) => {
            if(drawerNotSw.type == "main_video") pauseVideo();
            setDrawerNotSw({...drawerNotSw, show: false})
          }}
          onOpen={() => {}}
          style={{zIndex: drawerNotSw.zIndex}}
          className={"drawerFsGallery"}
      >
        {renderDrawerNotSwSwitch()}
      </Drawer>

    </main>
  );
};

export default Main;
